/**
 * WwexRates — front-end (1.10.6, 2026-10-21: NO "$0.00" / "FREE!" FLASH ON PAYMENT AND REVIEW. Guided test order
 * on test under 1.10.5 (50 ms sampling): arriving on Payment and on Review, the summary's Shipping line read
 * "$0.00" and the review <select> "Free! - WWEX Freight" for ~0.2 s before the 150 ms-debounced pass
 * repainted them. The 1.9.1 un-debounced observer bailed with a quote in hand whenever the shipmethod
 * module was absent. It now repaints the summary and the review <select> from the quote in the same
 * microtask on those steps too.)
 * prior: 1.10.5, 2026-10-21: THE BILLING FORM IS NOT THE SHIPPING ADDRESS, AND THE REVIEW
 * STEP ENDS ITS QUOTES. Guided test order on test.suppliedenergy.com under 1.10.4 (2 x item 2852, ship
 * to NH 03860, billing address Greenville IL 62246): the quote table shows the cart rated to 62246
 * ($376.19) and 03860 ($383.67) alternately while the shopper was on Payment and Review, and Review
 * showed "Free! - WWEX Freight" with the summary on "Calculating…" for up to 25 s. (a) shipInput()'s
 * fallbacks ('.order-wizard-address-module [name]', then document-wide) matched the BILLING form on the
 * Payment step — which also ticked the billing form's Residential box via the 1.7.0 default. The address
 * FORM is now read only on the shipping step (the shipmethod module is on the page, S1) and never an
 * id starting "bill"; elsewhere the model's selected shipping address is the source. (b) paint() with no
 * shipmethod module (Review) returned without ending the pending cycle, so every Review-step quote ran
 * the 25 s watchdog — and 1.10.4's pending hold kept "Calculating…" and blocked the review <select>
 * repaint for all of it. A resolved request now always ends the cycle. (c) While pending, the review
 * <select>'s selected WWEX option reads "Calculating… - <label>" instead of the native "Free!".)
 * prior: 1.10.4, 2026-10-21: NOTHING STALE OR FREE WHILE A RE-QUOTE IS IN FLIGHT.
 * Measured on www under 1.10.3 with 25 ms sampling, after an ADDRESS edit (same cart, new key):
 * (a) after a failed quote, both rows read "Free!" for 9.5 s until the new price landed — the
 * re-price path keeps rows on screen on the assumption they already show a real price, and with
 * no quote they showed the native $0.00; (b) with a price on screen, SCA re-rendered the row and
 * the 1.9.1 observer repainted the PREVIOUS quote ($383.67) and killed the spinner for 8 s before
 * $518.63 arrived, and the summary flashed "$0.00" for ~40 ms. Now: re-price mode requires a
 * quote in hand (else full pending, rows hidden); and while any rating cycle is pending, both
 * repaint paths hold the pending presentation (mode row "Finding the best shipping rate…" with its
 * spinner, summary "Calculating…") instead of painting the old quote.)
 * prior: 1.10.3, 2026-10-21: the summary's Shipping line no longer flashes "$0.00" when
 * SCA re-renders it mid-quote — see (d) below. 1.10.2 activated on test 2026-10-21 without it.)
 * prior: 1.10.2, 2026-10-20: A WAIT THAT LOOKS LIKE WORK. Measured on www the same
 * day: an LTL quote takes 10-12 s, the spinner said "Getting live rates…" the whole time, and the
 * 12 s stranding watchdog could fire "Rate unavailable" just before a good answer landed — more so
 * now that SL v0.5.2 may retry a WWEX 5xx server-side. (a) The spinner reads "Finding the best
 * shipping rate…" and, after PENDING_SLOW_MS (6 s), "Comparing options… this can take up to 30
 * seconds" (class sea-wwex-slow on <html>, CSS only). (b) PENDING_MAX_MS 12 s -> 25 s. (c) While a
 * rate request is in flight with no quote, the order-summary Shipping line reads "Calculating…"
 * instead of "At checkout"; it returns to "At checkout" when the cycle ends without a price. (d) That
 * line is now held by the un-debounced observer too: measured on test, an SCA summary re-render
 * mid-quote showed the native "$0.00" for ~0.3 s.)
 * prior: 1.10.1, 2026-10-20: A FAILED QUOTE NO LONGER SHOWS "FREE!". Customer
 * report: free shipping on the delivery step, then "shipping not available" at payment (2 x item
 * 2852 to NH 03860; WWEX answered HTTP 500 once and the order was unrateable). Two gaps. (a) The
 * failure copy was written onto the WWEX rows ONCE; SCA re-renders the rows (clicking one is
 * enough), a fresh row carries 12311's native $0.00 = "Free!", and nothing put the copy back:
 * noQuoteNeedsPaint() covered the review select, cart and summary but not the rows, and the 1.9.1
 * un-debounced observer bails without a quote. state.rowCopy now records whatever no-quote text
 * the rows were given (rate unavailable, contact-us, enter a ZIP) and both repaint paths restore
 * it. (b) carrier_error and auth_failed join RETRYABLE_QUOTE_STATUSES, so a WWEX hiccup is asked
 * again instead of sticking for the session; SL_sea_wwex_rates v0.5.2 also retries a WWEX 5xx once
 * server-side.)
 * prior: 1.10.0, 2026-09-30: HANDLING IN THE ONE SHIPPING NUMBER. Boss decision:
 * no card surcharge on web orders; instead custscript_swr_handling_pct % of the merchandise
 * subtotal rides inside the shipping figure, and the shopper sees ONE "Shipping" amount — no
 * separate carrier vs handling lines anywhere. The engine (SL_sea_wwex_rates v0.5.0) does the
 * arithmetic and returns options[0].amount already inclusive, so nothing about how this file
 * paints changes. Two things do: the request carries `subtotal` (LiveOrder summary subtotal net
 * of discount — NetSuite's own number for this shopper), and that subtotal joins the cache key
 * so a promo code or quantity edit re-quotes instead of leaving a stale handling on screen.
 * UE_sea_wwex_shipcost v0.8 re-derives the handling from the SO at submit, so the browser still
 * never dictates a price.)
 * prior: 1.9.1, 2026-09-01: the delivery rows no longer flash the ship items' native
 * "Free!" when SCA re-renders them on an unrelated field like phone. Repaint moved off the 150ms
 * debounce onto a dedicated observer, whose microtask runs before the browser paints.)
 * prior: 1.9.0, 2026-09-01: a phone edit no longer re-quotes — address reads are
 * scoped to the SHIPPING form and city/state are keyed by presence, not value. And a cart with no
 * rateable zip holds the rows down with "enter a valid US ZIP" instead of revealing them at the
 * ship items' $0.00, which is what "fail visible" had quietly become.)
 * prior: 1.8.1, 2026-08-31: review fixes. The rate request posts the destination the
 * cache key was built from — 1.6.0 left it reading raw DOM inside the debounce. Review-select label no
 * longer rebuilt from overwritten text. Failure copy and the no-quote neutralisers survive a re-render.
 * Boot watchdog no longer fires into a live rating cycle. See docs/wwex-verification-1.8.1.md.)
 * prior: 1.8.0, 2026-08-31: NEVER SHOW FREE. Every surface that could display the
 * ship items' $0.00 — the cart summary, the review <select>, the checkout order summary — now shows
 * a WWEX number or "At checkout", never a zero. Stale comments corrected.)
 * prior: 1.7.0, 2026-08-31: "This is a Residential Address" is ticked by default on
 * a NEW address. Deliberate amendment to this extension's contract — see CONFIG.RESIDENTIAL_DEFAULT.)
 * prior: 1.6.0, 2026-08-31: spinner in the delivery panel while rating, and a
 * phone-number edit no longer re-quotes — destination reads are sticky and a destination-only
 * change re-prices the row in place instead of blanking the panel.)
 * prior: 1.5.1, 2026-08-31: the one-option hide is a CSS rule armed at boot, not a
 * JS write that lands after the rows have already painted; covers re-renders too.)
 * prior: 1.5.0, 2026-08-31: ONE OPTION. Both WWEX rows are hidden while the
 * rating call is in flight and only the matching-mode row is revealed, so the shopper never sees
 * two choices at the ship items' $0.00 flat rate. Watchdog reveals them if no quote arrives.)
 * prior: 1.3.0, 2026-08-24: CART PAGE covered — extension now also runs in the shopping application; the cart's shipping estimate shows the WWEX quote or 'At checkout', never the flat rate)
 * Supplied Energy, LLC
 *
 * Shows the shopper REAL Worldwide Express prices on the checkout delivery step, in place of
 * the flat $0 the WWEX ship items carry natively. The authoritative flow:
 *
 *   1. When the delivery-method step renders and a destination zip is known, POST the cart
 *      (item ids + qty) and destination to SL_sea_wwex_rates.
 *   2. The Suitelet returns priced options and PERSISTS each quote server-side. We display the
 *      returned amounts on the WWEX method rows and mirror them into the order-summary shipping
 *      line and total, so what the shopper reviews equals what the UE will apply.
 *   3. At submit, UE_sea_wwex_shipcost re-derives the cart signature and applies the matching
 *      persisted quote as shippingcost — the price shown here is never sent back by the browser.
 *
 * GOVERNING PRINCIPLE (house rule, earned by GuestCheckout 0.4.x): FAIL VISIBLE, and measure
 * the rendered page — a selector resolving is not proof it renders. If quoting fails, the WWEX
 * rows show QUOTE_UNAVAILABLE_COPY instead of a fake price; nothing is ever blanked; the native
 * page is left alone whenever expectations aren't met.
 *
 * CONTRACT with GuestCheckout: this module touches ONLY the delivery-method step and the
 * order-summary shipping line. The checkout entry route, login page, and email field belong to
 * GuestCheckout/LoginControls — do not reach into them from here.
 *
 * ── SPIKE ITEMS — status as of 2026-08-24, measured on the rendered test checkout ────────────
 *   S1. RESOLVED. Selectors measured against TT_Master_Theme's live checkout DOM (see SEL).
 *       Address + delivery method are ONE step; methods render the moment the address is valid.
 *   S2. RESOLVED. Cart read from require('LiveOrder.Model').getInstance() — measured working —
 *       with SC.ENVIRONMENT.CART.lines[].item.internalid as the bootstrap fallback. The old
 *       read sent the LINE id ("item6480set260"), which no item lookup would ever match.
 *   S3. Re-quote triggers: address edit, cart edit mid-checkout, method re-render. The wizard
 *       re-renders modules on step change; the MutationObserver latch handles the common case.
 *   S4. RESOLVED. The zip input (name="zip", id shipaddress-zip) is on the same step as the
 *       method list, so it is readable whenever this extension has work to do.
 *   S5. Fortis auth-amount verification (see UE header) — order total authorized must equal
 *       UE-adjusted total. This is a stop-the-project check if it fails. STILL THE GATE.
 *
 * SCOPE: `checkout` + `shopping` entry points (shopping added 1.3.0 for the cart page).
 */
// 'Utils' is declared as a real AMD dependency exactly as the SDK's own SS2Model.js template does
// (define([..., 'Utils'])) — resolveServiceUrl needs Utils.getAbsoluteUrl to build the /scs_ss2/
// service URL, and the 1.0.x sync require('Utils') was an unverified fallback, kept below only as
// a belt-and-suspenders second path.
define('SuppliedEnergy.WwexRates.WwexRates', ['Utils'], function (UtilsDep) {
	'use strict';

	var CONFIG = {
		// RESOLVED 2026-08-14. Script 4164 (SEA WWEX Rates), deployment 8510, Released,
		// Available Without Login, Execute As Role "Web Activation Service".
		//
		// This is deliberately the RELATIVE path, not the extforms external URL. NetSuite also
		// issues an https://7375468.extforms.netsuite.com/... URL for this deployment, but that
		// host requires the session `ns-at` token — which guest checkout JS cannot supply. That
		// is exactly what killed the retired SL_sea_checkout_provision (see its header). The
		// SuiteCommerce domain serves /app/site/hosting/scriptlet.nl itself, so calling it
		// relative keeps the request SAME-ORIGIN on www/test: no ns-at, no CORS, no preflight.
		//
		// ⚠ BLOCKED 2026-08-20 — this transport does not work and the extension is idle until it
		// is replaced. MEASURED from a guest session on test.suppliedenergy.com, every form of
		// this call returns HTTP 500 "Invalid page parameter. Unable to view page.":
		//     ?script=4164&deploy=1                       (the URL the deployment record itself
		//                                                  prints, and what shipped here)
		//     ...&compid=7375468                          (numeric ids + company id)
		//     ?script=customscript_sea_wwex_rates&deploy=customdeploy1[&compid=7375468]
		//     all of the above as GET, as JSON POST, as form POST, and as text/plain POST
		//
		// It is NOT a missing `h` hash — the deployment has no anonymous hash URL; its External
		// URL is the extforms host with a session `ns-at` token, which guest JS cannot supply.
		// It is NOT this script either. Two controls prove that:
		//     - a BOGUS script id returns a DIFFERENT error, "That Suitelet is invalid, disabled,
		//       or no longer exists", so the storefront resolves our Suitelet fine
		//     - no params at all returns "This request is missing a required parameter", so
		//       scriptlet.nl is genuinely served on the SuiteCommerce domain
		// So the Suitelet is found and refused, consistently, however it is addressed.
		//
		// THE FIX is an extension SERVICE FILE, which is the supported way for a SuiteCommerce
		// extension to reach server code. 1.0.5 uses the SuiteScript 2 flavour: the .ss lives at
		// Modules/WwexRates/SuiteScript2/ and is listed under manifest "suitescript2.files"
		// (SERVICE_PATH below; resolveServiceUrl builds the /scs_ss2/ URL). The thinnest version
		// forwards this JSON body to the Suitelet server-to-server, so all the rating logic stays
		// exactly where it is and nothing about SL_sea_wwex_rates changes.
		//
		// Empty keeps the extension idle with a console warning rather than breaking checkout,
		// which is the correct failure mode until the service file exists.
		SUITELET_URL: '',

		// The SuiteScript 2 service file, relative to the extension's deployed root. Resolved at
		// runtime (see resolveServiceUrl) rather than hard-coded, because the deployed path
		// carries the vendor, extension name and VERSION — hard-coding it means the next version
		// bump silently breaks checkout.
		//
		// 1.1.0: path is the SDK's SuiteScript2 slot, matching the generator's SS2Model template
		// (Modules/<Module>/SuiteScript2/<Name>.Service.ss) and manifest suitescript2.files.
		// (0.1.3 pointed at assets/services — the SuiteScript 1.0 + ServiceController slot — and
		// 1.0.x still carried the stale 'services/' path here even after the slot was corrected.)
		SERVICE_PATH: 'Modules/WwexRates/SuiteScript2/WwexRates.Service.ss',
		// RESOLVED 2026-08-14 — the two ship items exist. Strings, matching the UE's list.
		//   12310 "WWEX Shipping" (parcel) · 12311 "WWEX Freight" (LTL)
		SHIP_ITEM_IDS: { parcel: '12310', ltl: '12311' },
		// The legacy order-total table ("Shipment"). Kept web-visible during the TRANSITION:
		// carts that quote live get it HIDDEN (no picking the cheap table over a real rate);
		// carts that can't quote (an item still missing weight/dims) fall back to it natively.
		LEGACY_SHIP_ITEM_ID: '12007',
		// TRANSITION MODE. false = hybrid: unquotable carts silently use the legacy table.
		// true = unquotable carts see the contact-us message instead of any self-serve rate.
		//
		// SET TRUE 2026-08-14 (KT) after the ship-data population run: weight + shipping L/W/H
		// are now populated on 1,212 of the 1,214 web-displayed inventory items (CSV import
		// "SE | Item Ship Data - Weight and Dims", 1214/1214 successful, verified against saved
		// search 2306). The two without data — 4289 / 4608, Enertech extended warranties — are
		// non-physical and are excluded from rating in the Suitelet's enrich(), so they do not
		// make a cart unquotable.
		//
		// STILL OUTSTANDING BEFORE THIS GOES LIVE (see docs/wwex-live-rates.md go-live gate):
		//   - "Shipment" (12007) still has Display in Website TICKED. Untick it at go-live;
		//     until then STRICT only takes effect for carts this extension actually quotes.
		//   - Coverage is measured over web ITEMS, not yet over web ORDERS. Run the 7-day
		//     cart-quotability stat once real rates are flowing and confirm it clears ~95%.
		STRICT: true,
		// PICKUP GUARD (1.4.0). Ship item id → the NetSuite LOCATION the collection happens at.
		// VERIFIED 2026-08-25 against the location table and against the storefront item API's own
		// quantityonhand_detail.locations[].internalid, which use the same ids:
		//     1 Greenville · 2 Newnan · 3 Catoosa · 4 Whisper Valley · 101 Austin · 103 Grand Cayman
		// Only three pickups are web-displayed; 4435 "Customer Pick Up - Catoosa" came off the store
		// 2026-08-06, which is why 29 Catoosa-only items are collectable NOWHERE.
		// Keep ids as STRINGS — data-value on the row is a string.
		PICKUP_LOCATIONS: {
			'4433': { location: 1,   label: 'Greenville' },
			'4434': { location: 2,   label: 'Newnan' },
			'4436': { location: 101, label: 'Texas' }
		},
		// Master switch. false = the guard does nothing at all (used to prove the server-side
		// backstop in UE_sea_wwex_shipcost v0.6 still catches an ineligible pickup).
		PICKUP_GUARD: true,
		// false = ineligible pickups stay visible but disabled, with the reason where the price was
		// — a shopper who came to collect learns WHY. true = hide the row entirely.
		PICKUP_HIDE_INELIGIBLE: false,
		// true = when a cart first paints with a pickup pre-selected and a priced WWEX row on
		// screen, move the selection onto the WWEX row. Moves ONCE per cart, and never after the
		// shopper has clicked a method themselves. This is what stops "free by default".
		PICKUP_STEAL_DEFAULT: true,
		// 1.4.2 — statuses worth trying again. Anything transport-shaped: a cold service file
		// right after an activation, a dropped connection, a malformed answer. Deliberately NOT
		// no_shippable_items or missing_item_data, which are permanent facts about this cart and
		// already render their own copy.
		// 1.9.0 — 'need_address' joins the list. City/state are keyed by PRESENCE now, so a
		// request that lands mid-render and is told need_address would otherwise never be
		// re-asked: the key does not move when the values reappear, only when presence flips.
		// 1.10.1 — carrier_error and auth_failed join. Both are WWEX (or its token endpoint) failing,
		// not facts about the cart: 2026-10-20 a single shopFlow HTTP 500 left a shopper with no
		// rate for the whole session, and the same cart priced normally minutes later. Deliberately
		// still NOT no_offers / ineligible / too_many_packages, which answer the same every time.
		RETRYABLE_QUOTE_STATUSES: ['error', 'need_address', 'carrier_error', 'auth_failed',
		                           'suitelet_unreachable', 'suitelet_bad_response',
		                           'service_no_https', 'service_no_url_module',
		                           'service_url_resolve_failed', 'service_url_resolve_empty'],
		QUOTE_MAX_TRIES: 2,
		REQUOTE_DEBOUNCE_MS: 400,

		// 1.5.0 — PENDING HIDE. NetSuite paints the native method list before the rating call
		// returns, so BOTH WWEX rows sit on screen at their ship item's own flat rate for the
		// life of the request. Those flat rates are $0.00 (measured on 12310/12311, 2026-08-31),
		// so the shopper is shown two shipping choices, both reading "Free!", and then watches one
		// vanish and the other acquire a real price. Hide both for the duration and let paint()
		// reveal only the matching-mode row: one option, the right one, at the WWEX price.
		// PENDING_MAX_MS is the stranding guard. 12310/12311 are the ONLY web-displayed shipping
		// items (12007 is not displayed, and the four Customer Pick Up items came off the web store
		// on 2026-08-31), so if a quote never resolves the rows MUST come back or the cart has no
		// selectable shipping method at all.
		PENDING_HIDE: true,
		// 1.10.2 — 12000 -> 25000. MEASURED on www 2026-10-20: an LTL quote (2 x item 2852 to NH)
		// took 10-12 s, so 12 s was a coin toss, and SL v0.5.2 can add a second WWEX call on a 5xx.
		// A late answer still paints after the watchdog, but the shopper has been told
		// "Rate unavailable" in between.
		PENDING_MAX_MS: 25000,
		// 1.10.2 — after this long in the full pending state the spinner label changes to
		// COPY.quotingSlow, so a long wait reads as progress rather than a hang.
		PENDING_SLOW_MS: 6000,

		// 1.5.1 — CSS ARM. 1.5.0 hid the rows from paintPending(), i.e. only once a rate request
		// started: the list renders, the 150ms-debounced observer fires, THEN the hide lands, and
		// the shopper sees both rows in between. Worse, a re-render with an unchanged cart+zip key
		// never calls paintPending at all (requestQuotes is skipped), so the native rows came back
		// and stayed until the debounced repaint. A stylesheet keyed off a class on <html> is
		// applied by the browser as each row paints, so timing stops mattering and re-renders are
		// covered for free. BOOT_MAX_MS is the same stranding guard as PENDING_MAX_MS, for the
		// window between arming at boot and the first quote resolving.
		ARM_ON_BOOT: true,
		BOOT_MAX_MS: 15000,

		// 1.7.0 — tick "This is a Residential Address" by default on a NEW address.
		// CONTRACT AMENDMENT, deliberate (KT 2026-08-31): the standing rule was that this
		// extension touches ONLY the delivery-method UI and the order-summary shipping/tax/total.
		// The residential flag is a shipping input this extension already reads for its cache key,
		// so it is brought in scope. It is the ONLY address-form field this extension may write.
		// NOTE ON PRICE: on the current WWEX credential this cannot change a quote. estimateQuoteFlow
		// (the only flow that rates here) has no residential input, and shopFlow, which carries
		// residentialDeliveryFlag, answers ineligible to everything — measured 2026-08-14, same
		// $154.76 LTL and $9.42 parcel either way (docs/wwex-residential.md). What it changes is the
		// value SAVED on the address, which is what reaches the label and what WWEX bills a
		// residential surcharge against afterwards. If shopFlow is ever entitled, this becomes a
		// pricing default too and should be revisited.
		RESIDENTIAL_DEFAULT: true,

		// 1.9.0 — the ZIP the Suitelet (and WWEX) will accept: 5 digits, optional +4. Kept here so
		// the front end refuses exactly what the back end refuses, instead of sending a request that
		// comes back invalid_destination and leaving the rows on their native price.
		ZIP_RE: /^\d{5}(-\d{4})?$/,
		ZIP_ENFORCE: true,

		// 1.8.1 — last-resort labels for the review <select>. Its native option text is
		// "$0.00 - WWEX Freight"; once we overwrite that with a status message the carrier name is
		// gone, and the success path used to rebuild the label from whatever text was there —
		// producing "$154.76 - At checkout". The original is stashed per option on first sight;
		// these cover the case where the first sight is already a failure.
		SHIP_ITEM_LABELS: { '12310': 'WWEX Shipping', '12311': 'WWEX Freight' }
	};

	var COPY = {
		// 1.10.2 — wording per Boyd 2026-10-20. quotingSlow replaces it after PENDING_SLOW_MS.
		quoting: 'Finding the best shipping rate…',
		quotingSlow: 'Comparing options… this can take up to 30 seconds',
		// 1.10.2 — the order-summary Shipping line while a rate request is in flight.
		calculating: 'Calculating…',
		unavailable: 'Rate unavailable — please try again or contact us',
		// 1.8.0 — what a shipping line says when WWEX has not given us a number. Never a zero,
		// never blank: a blank cell renders as free just as loudly as the word does.
		atCheckout: 'At checkout',
		// 1.9.0 — shown on the WWEX rows when there is a cart but no rateable destination yet.
		needZip: 'Enter a valid US ZIP code for shipping',
		zipInvalid: 'Enter a valid US ZIP code (5 digits)',
		missingData: 'This item needs a freight quote — contact us to complete your order',
		ltlLabel: 'Freight (LTL) — delivered by Worldwide Express',
		parcelLabel: 'Ground shipping',
		pickupChecking: 'Checking stock…',
		// Deliberately short: it replaces the price text, in the price column of the row.
		pickupShort: function (label, n) {
			return 'Not at ' + label + ' — ' + n + (n === 1 ? ' item' : ' items');
		}
	};

	// S1 RESOLVED — every selector below was MEASURED on the rendered checkout at
	// test.suppliedenergy.com #shipping/address, 2026-08-24, with a live cart (MC4-F, $6.04).
	// TT_Master_Theme renders address + delivery method as ONE step: the method list appears in
	// .order-wizard-shipmethod-module on the same page as the address inputs the moment the
	// address becomes valid. Each option row is .order-wizard-shipmethod-module-option carrying
	// the ship item id in data-value and a radio input[name="delivery-options"][value=<same id>].
	// The 2026-08-24 measurement listed 4433/4434/4436 pickups + 12007 legacy; as of 2026-08-31
	// the pickups came off the web store and 12007 is not web-displayed, so the only rows that
	// render are 12310 and 12311.
	var SEL = {
		deliveryStep: '.order-wizard-shipmethod-module',
		methodRow: '.order-wizard-shipmethod-module-option',
		methodRowIdAttr: 'data-value',
		methodPrice: '.order-wizard-shipmethod-module-option-price',
		// Order summary, measured: <span class="...shipping-cost-formatted"> $0.00 </span> and
		// the total amount in <div class="...summary-total"><span class="...grid-right"> $6.57 </span>
		summaryShipping: '.order-wizard-cart-summary-shipping-cost-formatted',
		summaryTax: '.order-wizard-cart-summary-tax',
		summaryTotal: '.order-wizard-cart-summary-total .order-wizard-cart-summary-grid-right',
		// 1.2.4 — the REVIEW step (measured 2026-08-24 on www #review): no shipmethod module, no
		// address inputs; the method lives in a <select name="delivery-options"> whose option
		// values are the ship item ids and whose texts read "$250.00 - WWEX Shipping".
		reviewSelect: 'select.order-wizard-showshipments-module-shipping-options',
		// 1.3.0 — the CART page (shopping application; measured 2026-08-24 on www /cart): the
		// native summary shows the model's shipping ESTIMATE, which for a WWEX method is the raw
		// $250 flat rate. Classes measured live.
		cartShipping: '.cart-summary-amount-shipping',
		cartTax: '.cart-summary-amount-tax',
		cartTotal: '.cart-summary-amount-total'
	};

	var state = { lastKey: null, quotes: null, inFlight: false,
	             container: null, serviceUrl: '',
	             // pickup guard (1.4.0), deliberately independent of the rating latch above
	             stockKey: null, stock: null, stockInFlight: false, stockTries: 0,
	             userChose: false, defaultMoved: false,
	             quoteTries: 0,
	             // 1.5.0 pending-hide latch + its stranding-guard timer
	             pending: false, pendingTimer: null,
	             // 1.10.2 — swaps the spinner label to COPY.quotingSlow
	             slowTimer: null,
	             // 1.5.1 css arm
	             armed: false, bootTimer: null,
	             // 1.6.0 — sticky destination reads, the cart-derived mode latch, request debounce
	             sticky: {}, mode: null, cartSig: null, requoteTimer: null, repricing: false,
	             // 1.7.0 — the shopper's own decision about residential, once made, is final
	             resiUserTouched: false,
	             // 1.8.1 — the last result, kept so a re-render can re-apply the SAME copy instead
	             // of downgrading a contact-us message to the generic at-checkout wording.
	             lastResult: null, lastStatus: '',
	             // 1.9.1 — re-entrancy guard for the un-debounced row observer
	             repainting: false,
	             // 1.10.1 — the text the WWEX rows were given while there is NO quote (rate
	             // unavailable, contact-us, enter a ZIP). A re-render restores the ship item's native
	             // "Free!"; the repaint paths put this back. null = nothing to hold.
	             rowCopy: null };

	// --- wiring ------------------------------------------------------------------------------

	// Resolve where to POST rate requests. Preference order:
	//   1. the extension's SuiteScript 2 service file. The build scopes a function
	//      getExtensionAssetsPath(asset) into this extension's closure (see the SDK's
	//      gulp/extension-mechanism/local-tasks/javascript.js generateGetAssetsPathFunction) that
	//      returns 'extensions/<vendor>/<name>/<version>/' + asset, so the version segment is
	//      always right. Utils.getAbsoluteUrl(path, true) then turns that into the SS2 service
	//      URL — MEASURED on test 2026-08-21: https://<domain>/scs_ss2/extensions/... . This is
	//      exactly what the SDK's own SS2Model.js template does. (0.1.3 looked for
	//      container.getExtensionAssetsPath, which does not exist, so it always fell idle.)
	//   2. an explicit SUITELET_URL override, for local testing from inside the NetSuite app
	//      domain where scriptlet.nl does resolve
	// Returns '' if neither is available, which leaves the extension idle rather than firing
	// requests into a 500 on every keystroke of the delivery step.
	function resolveServiceUrl() {
		try {
			if (typeof getExtensionAssetsPath === 'function') {
				var rel = getExtensionAssetsPath(CONFIG.SERVICE_PATH);
				if (rel) {
					var Utils = UtilsDep || null;
					if (!Utils) { try { Utils = require('Utils'); } catch (e) { Utils = null; } }
					if (Utils && typeof Utils.getAbsoluteUrl === 'function') {
						var abs = Utils.getAbsoluteUrl(rel, true);
						if (abs) { return abs; }
					}
					// Utils missing: do NOT guess the /scs_ss2/ prefix. Fall through and stay idle.
					try { console.warn('[WwexRates] Utils.getAbsoluteUrl unavailable; not guessing service URL'); } catch (e2) {}
				}
			}
		} catch (e) { /* fall through to the override */ }
		return CONFIG.SUITELET_URL || '';
	}

	function boot() {
		state.serviceUrl = resolveServiceUrl();
		if (!state.serviceUrl) {
			// Not configured — do nothing, loudly, once. Native page untouched.
			try {
				console.warn('[WwexRates] no service URL resolved (container missing and ' +
				             'SUITELET_URL unset); extension idle.');
			} catch (e) {}
			return;
		}
		try { console.info('[WwexRates] rating via ' + state.serviceUrl); } catch (e) {}

		// 1.5.1 — arm BEFORE the wizard can render a method row. Only ever reached with a resolved
		// service URL, so a misconfigured extension still leaves the native page completely alone.
		// 1.8.1 — boot() runs TWICE in the normal case: the DOMContentLoaded path fires first, then
		// mountToApp sets booted=false and re-enters so the container can resolve the service URL.
		// Without this clear the second pass overwrote state.bootTimer and orphaned the first, and
		// re-armed 'pending' — so a late mountToApp could slam both rows back into hiding for 15s
		// after a quote had already painted.
		clearBootTimer();
		if (CONFIG.PENDING_HIDE && CONFIG.ARM_ON_BOOT && !state.quotes && !state.inFlight) {
			injectArmCss();
			setArm('pending');
			state.bootTimer = setTimeout(function () {
				state.bootTimer = null;
				// A rating cycle owns the outcome from the moment one starts.
				if (state.quotes || state.pending || state.inFlight || state.requoteTimer) { return; }
				// 1.9.0 — never disarm into a cart with no rateable destination: revealing the rows
				// there shows the ship items' $0.00. Nothing is stranded, because no method can be
				// quoted until the zip is real.
				if (!readZip()) {
					try { console.warn('[WwexRates] boot guard: no valid zip — rows stay hidden'); } catch (e0) {}
					setArm('hide-both');
					return;
				}
				try { console.warn('[WwexRates] no quote ' + CONFIG.BOOT_MAX_MS + 'ms after boot — ' +
				                   'disarming so the cart is not left unshippable'); } catch (e) {}
				setArm(null);
				revealPendingRows(null);
			}, CONFIG.BOOT_MAX_MS);
		}

		var mo = new MutationObserver(debounce(onDomChange, 150));
		mo.observe(document.body, { childList: true, subtree: true });

		// 1.9.1 — THE FLICKER. SCA re-creates the delivery-method rows on ANY change to the address
		// model, phone number included. A freshly rendered row carries NetSuite's own price text,
		// which for 12310/12311 is $0.00 and renders as "Free!", and the repaint that replaces it
		// with the quote sat behind the 150ms-debounced observer above — so a phone keystroke showed
		// Free and then the real number. 1.9.0 stopped the re-QUOTE; this stops the re-RENDER
		// showing through. 1.5.1's CSS arm already fixes row VISIBILITY against a re-render for
		// free, because a class on <html> applies as each row paints; the price TEXT cannot work
		// that way, so instead it is repainted with NO debounce. MutationObserver callbacks are
		// microtasks: they run at the end of the current task, BEFORE the browser paints, so the
		// native text never reaches the screen.
		//
		// Cheap by construction: bails immediately unless a quote is cached, then one querySelector
		// and a scan of at most two rows. Cannot loop — paint() only mutates rows that disagree with
		// the quote, and wwexRowsNeedPaint() goes false once they agree, but the guard makes that
		// explicit rather than load-bearing.
		try {
			var rowMo = new MutationObserver(function () {
				if (state.repainting) { return; }
				// 1.10.4 — mid-cycle, never paint the previous quote: hold "finding…" + "Calculating…".
				if (state.pending) {
					var stepP = document.querySelector(SEL.deliveryStep);
					if (!pendingNeedsPaint(stepP)) { return; }
					state.repainting = true;
					try { repaintPending(stepP); } catch (ePend) {}
					state.repainting = false;
					return;
				}
				// 1.10.1 — no quote: the rows must keep their no-quote copy through a re-render, or
				// the shopper reads "Free!" (the 2026-10-20 complaint). Same microtask timing as below.
				// 1.10.2 — the summary's Shipping line too. MEASURED on test 2026-10-21: while a quote
				// was in flight, SCA re-rendered the summary twice (address/phone edits) and it read
				// "$0.00" for ~0.3 s each time until the 150 ms-debounced repaint caught it.
				if (!state.quotes) {
					var sumNeed = noQuoteSummaryNeedsPaint();
					var stepNq = state.rowCopy ? document.querySelector(SEL.deliveryStep) : null;
					var rowNeed = !!stepNq && rowCopyNeedsPaint(stepNq);
					if (!sumNeed && !rowNeed) { return; }
					state.repainting = true;
					try {
						if (rowNeed) { repaintRowCopy(stepNq); }
						if (sumNeed) { neutralizeSummary(); }
					} catch (eCopy) {}
					state.repainting = false;
					return;
				}
				var step = document.querySelector(SEL.deliveryStep);
				if (!step) {
					// 1.10.6 — Payment / Review: no rows, but the summary line and the review <select> are
					// re-rendered natively ($0.00 / "Free! - WWEX Freight") on every step change. Repaint
					// them from the quote now rather than 150 ms later (measured ~0.2 s of each on test).
					var sumQ = summaryNeedsPaint();
					var revQ = reviewNeedsPaint();
					if (!sumQ && !revQ) { return; }
					state.repainting = true;
					try {
						if (revQ) { paintReviewSelect(state.quotes); }
						if (sumQ) { paintSummary(state.quotes); }
					} catch (eNoStep) {}
					state.repainting = false;
					return;
				}
				if (!wwexRowsNeedPaint(step) && !summaryNeedsPaint()) { return; }
				state.repainting = true;
				try { paint(step, state.quotes); } catch (ePaint) {}
				state.repainting = false;
			});
			rowMo.observe(document.body, { childList: true, subtree: true });
		} catch (eRowMo) {
			try { console.warn('[WwexRates] row observer unavailable; flicker guard off', eRowMo); } catch (e2) {}
		}

		// 1.4.0 — any click on a delivery-method row is the shopper making a choice, and from that
		// moment the extension never moves the selection again (except off a BLOCKED row — leaving
		// that selected is the bug we are fixing). Capture phase so we see it even if SCA stops
		// propagation in its own handler.
		try {
			document.addEventListener('click', function (e) {
				try {
					var t = e.target;
					while (t && t !== document.body) {
						if (t.className && String(t.className).indexOf('order-wizard-shipmethod-module-option') !== -1) {
							state.userChose = true;
							return;
						}
						t = t.parentNode;
					}
				} catch (eIn) {}
			}, true);
		} catch (eOut) {}

		// 1.7.0 — once the shopper sets residential themselves, the default never applies again.
		// Capture phase, same reasoning as the row click above.
		try {
			document.addEventListener('change', function (e) {
				try {
					if (e.target && e.target.name === 'isresidential' && e.isTrusted !== false) {
						state.resiUserTouched = true;
						state.sticky.resi = e.target.checked ? 'T' : 'F';
					}
				} catch (eIn) {}
			}, true);
		} catch (eOut2) {}

		onDomChange();
	}

	function onDomChange() {
		// 1.7.0 — before anything reads the destination, so the first quote carries the default.
		applyResidentialDefault();
		// 1.2.4: the extension has work on TWO steps — the shipping step (method rows) and the
		// review step (method <select> + summary). Found idle on review 2026-08-24: KT saw both
		// WWEX options at the native $250 there because everything gated on the shipmethod
		// module, and the address reads gated on form inputs that only the blank guest form has.
		var step = document.querySelector(SEL.deliveryStep);
		var review = document.querySelector(SEL.reviewSelect);
		// 1.8.0 — do not wait for a paint() to reach the review step: with no quote in hand its
		// WWEX options still carry the ship item's own $0.00 text.
		// 1.8.1 — replay the LAST result rather than a bare null. paint() writes the STRICT copy
		// ("...contact us to complete your order") and state.quotes is null after any failure, so
		// with a null here the very next mutation tick recomputed failMsg as the generic
		// "At checkout" and silently downgraded the gate.
		if (review && !state.quotes && !state.pending) { paintReviewSelect(state.lastResult); }   // 1.10.5: not mid-cycle
		// 1.2.5: the summary module renders on EVERY wizard step (found on #billing — a page
		// with no method list and no review select, where the extension idled and the native
		// $250-based numbers showed). Any page carrying the summary is a page with work to do.
		var summaryHere = document.querySelector(SEL.summaryShipping);
		// 1.3.0: the CART page (shopping app) shows the model's raw estimate — KT decree: the
		// flat rate must never be shown, so the cart is handled even when nothing is quotable.
		var cartHere = document.querySelector(SEL.cartShipping);
		if (!step && !review && !summaryHere && !cartHere) { return; }
		var cart = readCart();
		var dest = readDest();
		var zip = dest.zip;

		// 1.4.0 PICKUP GUARD. Runs on the shipping step only, and does NOT wait for a destination:
		// whether an item is in the Greenville warehouse has nothing to do with where the shopper
		// lives. Placed before the zip early-return below, which would otherwise skip it entirely
		// for a cart with no address yet.
		if (step && CONFIG.PICKUP_GUARD && cart && cart.length) { runPickupGuard(step, cart); }
		if (!cart || !cart.length || !zip) {
			// No rateable destination (fresh shopper, or a zip that is not a zip).
			// 1.9.0 — this used to just return on checkout pages, with the comment "keep their
			// native rendering (fail visible) because the address form is right there". That was
			// written when 12310/12311 carried a $250 flat rate, so failing visible meant showing
			// $250. Since the cutover zeroed them it means showing FREE, and the boot watchdog
			// reveals both rows after 15s to boot. A shopper who mistypes a zip is shown free
			// shipping. Hold the rows down and say what is needed instead — there is nothing to
			// strand here, because no shipping method can be quoted until the zip is real.
			if (cartHere) { paintCartSummary(null); }
			if (step && cart && cart.length) {
				injectArmCss();
				setArm('hide-both');
				clearBootTimer();
				clearPendingTimer();
				state.pending = false;
				setRepricing(false);
				eachWwexRow(step, function (row) {
					row.removeAttribute('data-sea-wwex-pending');
					setPrice(row, null, COPY.needZip);
				});
				state.rowCopy = COPY.needZip;   // 1.10.1 — hold it through a re-render
				neutralizeSummary();
			}
			markZip();
			return;
		}
		markZip();

		// The readiness marker is a KEY, not a boolean, so anything that changes the PRICE
		// re-quotes instead of leaving a stale number on screen (spike S3). Residential is in the
		// key for historical reasons. STALE CLAIM REMOVED 2026-08-31: this said WWEX "really does
		// price it — $212.76 commercial vs $335.00 residential-with-liftgate". That predates the
		// 2026-08-14 finding (docs/wwex-residential.md) that this credential CANNOT rate
		// residential — estimateQuoteFlow has no residential input, shopFlow answers ineligible,
		// measured identical at $154.76 LTL / $9.42 parcel either way. Residential in the key buys
		// nothing today but a re-quote returning the same number. Kept because entitling shopFlow
		// would make it price-bearing again overnight; revisit it then, not before.
		// 1.6.0 — the cart signature is split out, because the two halves mean different things:
		// the CART decides the MODE (the Suitelet classifies parcel vs LTL from item weight and
		// dims alone) and the DESTINATION only decides the PRICE. So a destination-only change can
		// never move the shopper to the other carrier row, and must not blank the panel back to
		// pending — it re-prices the row already on screen. Shipping state joins the key: the
		// Suitelet needs city+state for LTL, so a state change is a real re-rate.
		var cartSig = cart.map(function (l) { return l.id + ':' + l.qty; }).sort().join(',');
		// 1.9.0 — city and state are no longer in the key BY VALUE, only by PRESENCE. The rate is
		// zip-driven; shopFlow needs city+state to make an LTL offer at all, but two spellings of
		// the same zip do not price differently. Keying on their values meant any re-render that
		// changed which DOM field was read (see shipInput) re-quoted a destination that had not
		// changed — the phone-edit reload. Presence still flips the key, so the first quote once an
		// address is complete still fires.
		var haveCityState = (dest.city && dest.state) ? '1' : '0';
		// 1.10.0 — the merchandise subtotal is part of the price now (handling), so it is part
		// of the key: a promo code or a summary quantity edit re-quotes. It is read from the
		// model, never the DOM, so a re-render cannot flip it.
		var subtotal = readSubtotal();
		var key = cartSig + '||' + zip + '|' + dest.resi + '|' + haveCityState + '|' + subtotal;
		var sameCart = (cartSig === state.cartSig);

		if (key === state.lastKey) {
			// Same cart + destination as the last quote. MEASURED at cutover 2026-08-24: the
			// wizard re-renders the option LIST under a STABLE module container — the quote had
			// been fetched before the WWEX rows existed, then the rows appeared carrying the
			// native $250 fallback and the old container-attribute latch said "already done"
			// forever. The latch now lives in JS state, and a matching key REPAINTS from the
			// cached result (no new request) whenever a visible WWEX row is not showing our
			// number. paint() only mutates rows that need it, so the MutationObserver does not
			// loop on its own paints.
			// 1.2.3: the summary needs the same treatment as the rows — selecting a method makes
			// SCA re-render the summary natively (from the server's $250-based numbers when WWEX
			// is chosen), so sync it whenever it disagrees with what should be shown.
			// 1.10.4 — a rating cycle is in flight: state.quotes (if any) is the PREVIOUS answer, and
			// painting it would show a stale price as final. Hold the pending presentation instead.
			if (state.pending) {
				if (pendingNeedsPaint(step)) { repaintPending(step); }
				return;
			}
			if (state.quotes && (wwexRowsNeedPaint(step) || reviewNeedsPaint() || summaryNeedsPaint() || cartNeedsPaint())) {
				paint(step, state.quotes);
			} else if (!state.quotes && noQuoteNeedsPaint()) {
				// 1.8.1 — this branch did not exist. Every needs-paint check was behind
				// `state.quotes`, which is null after ANY failure, so the 1.8.0 neutralisers fired
				// exactly once and never again: SCA re-renders the summary on a method change and
				// restored the native $0.00 permanently. summaryNeedsPaint() could not have helped —
				// it returns false when there is no option to compare against.
				repaintNoQuote();
			}
			return;
		}
		if (state.inFlight) { return; }   // key changed mid-request: retry on the next DOM tick

		state.lastKey = key;
		if (step) { step.setAttribute('data-sea-wwex-key', key); }   // observability only — logic uses state
		// Same cart, known mode → re-price in place (one row stays up, spinner in its price cell).
		// New cart → the mode is unknown again, so both rows go down behind the full pending state.
		// 1.10.4 — and only with a quote in hand. After a FAILED quote the rows are showing failure
		// copy, not a price; "re-price in place" left them up and a re-render put the native "Free!"
		// back for the whole ~10 s request (measured on www 2026-10-21). Full pending hides them.
		var reprice = sameCart && !!state.mode && !!state.quotes;
		if (!sameCart) { state.mode = null; }
		state.cartSig = cartSig;
		paintPending(reprice ? 'reprice' : 'full');
		requestQuotes(cart, dest, function (result) {
			state.quotes = (result && result.status === 'ok') ? result : null;
			state.lastResult = result || null;
			state.lastStatus = (result && result.status) || '';
			paint(document.querySelector(SEL.deliveryStep), result);
			// 1.4.2 — a failed request must not stick this cart+destination on the native price
			// FOREVER. state.lastKey was set before the request resolved, so without this the
			// `key === state.lastKey` early return fires on every later tick and the repaint
			// branch is gated on state.quotes being non-null: nothing ever tries again.
			// MEASURED on test 2026-08-25: rows sat on the native "Free!" for 18+ seconds with a
			// perfectly healthy service (a hand-made call returned ok / $33.53); changing the key
			// by ticking Residential painted $29.95 at once. Since the cutover zeroed the flat
			// rates, that stuck native text reads "Free!" — the shopper is shown free shipping and
			// the UE charges real freight at submit. Displayed != charged is the one outcome this
			// project exists to prevent, so it retries.
			// Only transport-ish failures retry. no_shippable_items and missing_item_data are
			// permanent facts about the cart and already paint their own correct copy.
			if (!state.quotes) {
				var st = (result && result.status) || 'error';
				if (CONFIG.RETRYABLE_QUOTE_STATUSES.indexOf(st) !== -1) {
					state.quoteTries = (state.quoteTries || 0) + 1;
					if (state.quoteTries <= CONFIG.QUOTE_MAX_TRIES) {
						try { console.warn('[WwexRates] quote ' + st + ' — retry ' + state.quoteTries); } catch (e) {}
						state.lastKey = null;
					}
				}
			} else {
				state.quoteTries = 0;
			}
		});
	}

	// True when a WWEX row is on screen but not displaying what the cached quote says it
	// should — either the wrong price text (e.g. the native $250 fallback after a re-render)
	// or a row that should be hidden because the cart's mode picked the other carrier row.
	function wwexRowsNeedPaint(step) {
		if (!step) { return false; }
		var need = false;
		eachWwexRow(step, function (row, kind) {
			var opt = pickOption(state.quotes, kind);
			// 1.5.0 — hidden rows can no longer be skipped outright. A row hidden by paintPending
			// (or left hidden by a previous cart's mode) that THIS quote says should be visible is
			// exactly the case a re-render must repaint; without this the wizard can re-render the
			// list after the quote landed and leave the shopper with no WWEX row at all.
			if (row.style.display === 'none') { if (opt) { need = true; } return; }
			var el = row.querySelector(SEL.methodPrice);
			if (!el) { return; }
			if (!opt) { need = true; return; }               // should be hidden
			if (el.textContent !== fmt(opt.amount)) { need = true; }
		});
		return need;
	}

	// 1.2.3 — which delivery method is the shopper on RIGHT NOW? The checked radio is the
	// immediate truth (input[name="delivery-options"], measured 2026-08-24); the LiveOrder
	// model's shipmethod is the server-synced fallback.
	function selectedShipMethodId() {
		try {
			var r = document.querySelector('input[name="delivery-options"]:checked');
			if (r && r.value) { return String(r.value); }
		} catch (e) {}
		try {
			var LO = require('LiveOrder.Model');
			var inst = LO && LO.getInstance && LO.getInstance();
			var m = inst && inst.get && inst.get('shipmethod');
			if (m) { return String(m); }
		} catch (e2) {}
		return '';
	}

	function wwexMethodSelected() {
		var id = selectedShipMethodId();
		return id === CONFIG.SHIP_ITEM_IDS.parcel || id === CONFIG.SHIP_ITEM_IDS.ltl;
	}

	// 1.2.4 — the review step's method <select>: rewrite the matching-mode WWEX option's price
	// text to the quoted amount and hide+disable the other-mode WWEX option (measured: option
	// values are ship item ids, texts like "$250.00 - WWEX Shipping").
	//
	// 1.8.0 — this used to return on any non-ok result and leave the native select alone, on the
	// reasoning that the shipping step's STRICT messaging was the gate. That reasoning died with
	// the flat rates: the native text is built from the ship item's own price, so at $0.00 the
	// review step offered "Free! - WWEX Freight" as a selectable option. No quote now means no
	// number — the options are withdrawn, and a selected one is relabelled rather than left
	// advertising free freight.
	// 1.8.1 — the option's carrier label, captured before we ever overwrite the text. The native
	// text is "$0.00 - WWEX Freight"; the success path used to slice the label out of whatever was
	// on screen, so once a failure had written "At checkout" there the shopper was shown
	// "$154.76 - At checkout". Stash on first sight, and fall back to CONFIG.SHIP_ITEM_LABELS when
	// the first sight is already a status message.
	function optLabel(o) {
		var stashed = o.getAttribute('data-sea-wwex-label');
		if (stashed) { return stashed; }
		var label = o.text.indexOf(' - ') > -1 ? o.text.slice(o.text.indexOf(' - ')) : null;
		if (!label) {
			var name = CONFIG.SHIP_ITEM_LABELS[o.value];
			if (!name) { return ''; }
			label = ' - ' + name;
		}
		o.setAttribute('data-sea-wwex-label', label);
		return label;
	}

	function paintReviewSelect(result) {
		var sel = document.querySelector(SEL.reviewSelect);
		if (!sel) { return; }
		var ok = !!(result && result.status === 'ok');
		var failMsg = (result && result.status === 'missing_item_data') ? COPY.missingData
			: (result ? COPY.unavailable : COPY.atCheckout);
		var i, o, kind, winner = null, strandedSelection = false;
		// Capture every label before the first write, whatever branch we are about to take.
		for (i = 0; i < sel.options.length; i++) {
			o = sel.options[i];
			if (o.value === CONFIG.SHIP_ITEM_IDS.parcel || o.value === CONFIG.SHIP_ITEM_IDS.ltl) { optLabel(o); }
		}
		for (i = 0; i < sel.options.length; i++) {
			o = sel.options[i];
			kind = o.value === CONFIG.SHIP_ITEM_IDS.parcel ? 'parcel'
				: (o.value === CONFIG.SHIP_ITEM_IDS.ltl ? 'ltl' : null);
			if (!kind) { continue; }
			if (!ok) {
				if (o.selected) { if (o.text !== failMsg) { o.text = failMsg; } }
				else { o.hidden = true; o.disabled = true; }
				continue;
			}
			var opt = pickOption(result, kind);
			if (opt) {
				var wanted = fmt(opt.amount) + optLabel(o);
				if (o.text !== wanted) { o.text = wanted; }
				o.hidden = false; o.disabled = false;
				winner = o;
			} else {
				// Wrong mode for this cart — a shopper must not be offered it. 1.8.1: a SELECTED
				// wrong-mode option used to be left alone entirely, so the review step could sit on
				// an enabled "WWEX Freight" for a cart that resolved to parcel. The row-level
				// selection move in paint() cannot reach this: it needs the shipmethod module, and
				// the review step has none. Move the selection here instead.
				if (o.selected) { strandedSelection = true; }
				else { o.hidden = true; o.disabled = true; }
			}
		}
		if (ok && winner && strandedSelection) {
			try {
				sel.value = winner.value;
				sel.dispatchEvent(new Event('change', { bubbles: true }));
			} catch (e) {
				try { var ev = document.createEvent('HTMLEvents'); ev.initEvent('change', true, false); sel.dispatchEvent(ev); } catch (e2) {}
			}
			// Now that nothing is selected on it, the loser can be withdrawn like any other.
			for (i = 0; i < sel.options.length; i++) {
				o = sel.options[i];
				if (o !== winner && (o.value === CONFIG.SHIP_ITEM_IDS.parcel || o.value === CONFIG.SHIP_ITEM_IDS.ltl)) {
					o.hidden = true; o.disabled = true;
				}
			}
		}
	}

	// 1.8.1 — is anything still showing a native zero while we have no quote to replace it with?
	function noQuoteNeedsPaint() {
		try {
			if (rowCopyNeedsPaint(document.querySelector(SEL.deliveryStep))) { return true; }
			if (reviewNeedsPaint()) { return true; }
			if (cartNeedsPaint()) { return true; }
			if (wwexMethodSelected()) {
				var el = document.querySelector(SEL.summaryShipping);
				if (el && el.textContent.trim() !== noQuoteSummaryText()) { return true; }   // 1.10.2
			}
		} catch (e) {}
		return false;
	}

	// Re-apply the no-quote presentation. Uses state.lastResult so a STRICT failure keeps ITS
	// copy instead of decaying to the generic wording on every re-render.
	function repaintNoQuote() {
		repaintRowCopy(document.querySelector(SEL.deliveryStep));
		neutralizeSummary();
		paintCartSummary(state.lastResult);
		paintReviewSelect(state.lastResult);
	}

	// 1.10.1 — is a WWEX row showing anything other than the no-quote copy it was given? Only
	// while there is no quote and no rating cycle in flight: pending/re-pricing own the rows then.
	function rowCopyNeedsPaint(step) {
		if (!step || state.quotes || state.pending || !state.rowCopy) { return false; }
		var need = false;
		eachWwexRow(step, function (row) {
			var el = row.querySelector(SEL.methodPrice);
			if (el && el.textContent !== state.rowCopy) { need = true; }
		});
		return need;
	}

	// Text only — visibility stays with the arm class and the inline display the failure path set.
	function repaintRowCopy(step) {
		if (!rowCopyNeedsPaint(step)) { return; }
		var text = state.rowCopy;
		eachWwexRow(step, function (row) {
			var el = row.querySelector(SEL.methodPrice);
			if (el && el.textContent !== text) { setPrice(row, null, text); }
		});
	}

	function reviewNeedsPaint() {
		var sel = document.querySelector(SEL.reviewSelect);
		if (!sel) { return false; }
		// 1.8.0 — with no quote the WWEX options must not be sitting there at the native price.
		if (!state.quotes) {
			for (var j = 0; j < sel.options.length; j++) {
				var oj = sel.options[j];
				if (oj.value !== CONFIG.SHIP_ITEM_IDS.parcel && oj.value !== CONFIG.SHIP_ITEM_IDS.ltl) { continue; }
				if (!oj.hidden && !oj.selected) { return true; }
			}
			return false;
		}
		for (var i = 0; i < sel.options.length; i++) {
			var o = sel.options[i];
			var kind = o.value === CONFIG.SHIP_ITEM_IDS.parcel ? 'parcel'
				: (o.value === CONFIG.SHIP_ITEM_IDS.ltl ? 'ltl' : null);
			if (!kind) { continue; }
			var opt = pickOption(state.quotes, kind);
			if (opt) {
				if (o.text.indexOf(fmt(opt.amount)) !== 0) { return true; }
			} else if (!o.hidden && !o.selected) { return true; }
		}
		return false;
	}

	// 1.3.0 — the CART page's summary (shopping application). The native line shows the
	// model's shipping ESTIMATE, which for a WWEX method (or no method at all with a WWEX
	// estimate lingering on the order) is the raw flat rate. KT decree: a number WWEX did not
	// supply is never shown — paint the real quote when the destination is known, otherwise
	// "At checkout", and strip the phantom estimate (and its tax) out of the displayed totals.
	// A pickup estimate (Free) is native behaviour and is left alone. DORMANT since 2026-08-31:
	// no pickup ship item is web-displayed any more, so the store cannot reach this branch. Kept
	// because pickup is expected back for Supplied Pro customers.
	function cartModelState() {
		try {
			var LO = require('LiveOrder.Model');
			var inst = LO && LO.getInstance && LO.getInstance();
			var sum = inst && inst.get && inst.get('summary');
			var method = String((inst && inst.get && inst.get('shipmethod')) || '');
			if (!sum) { return null; }
			var wwexish = method === CONFIG.SHIP_ITEM_IDS.parcel || method === CONFIG.SHIP_ITEM_IDS.ltl || method === '';
			return { sum: sum, method: method, wwexish: wwexish };
		} catch (e) { return null; }
	}

	function paintCartSummary(result) {
		var shipEl = document.querySelector(SEL.cartShipping);
		if (!shipEl) { return; }
		var st = cartModelState();
		// 1.8.0 — this used to bail on shippingcost <= 0. That guard was written when the WWEX ship
		// items carried a $250 flat rate (the measured summary was {shippingcost:250, ...}); once
		// the cutover zeroed them, a WWEX-method cart reports shippingcost 0, the function returned
		// early, and the native summary was left showing $0.00 — free shipping, on the cart page,
		// for exactly the carts this extension exists to price. A zero is now a value to REPLACE,
		// not a reason to walk away.
		if (!st || !st.wwexish) { return; }
		// 1.8.1 — dropping the shippingcost>0 test in 1.8.0 also dropped the only thing keeping this
		// off non-shipping carts: wwexish is true when method === '', so a warranty-only cart got
		// "At checkout" on a line that should say nothing. Shippability is the Suitelet's call, so
		// this is the signal we have. Known gap, accepted: before the first quote a non-shipping
		// cart still shows "At checkout" for a moment.
		if (state.lastStatus === 'no_shippable_items') { return; }
		var taxEl = document.querySelector(SEL.cartTax);
		var totalEl = document.querySelector(SEL.cartTotal);
		var s = st.sum;
		var sc = isFinite(s.shippingcost) ? s.shippingcost : 0;
		var opt = result && result.status === 'ok' && result.options && result.options[0];
		// 1.8.1 — sc is now always 0 for these carts (that is the whole point of the 1.8.0 change),
		// so this rate was always 0 and the quote went in untaxed: the cart under-reported and the
		// total jumped at checkout. These ship items are Taxable on the same schedule as the goods,
		// so fall back to the goods rate when there is no shipping cost to derive one from.
		var goodsTax = (isFinite(s.taxtotal) ? s.taxtotal : 0) - (isFinite(s.taxonshipping) ? s.taxonshipping : 0);
		var taxRate = (isFinite(s.taxonshipping) && sc > 0) ? (s.taxonshipping / sc)
			: ((isFinite(s.subtotal) && s.subtotal > 0) ? (goodsTax / s.subtotal) : 0);
		if (opt) {
			var q = Number(opt.amount);
			var qTax = Math.round(q * taxRate * 100) / 100;
			shipEl.textContent = fmt(q);
			if (taxEl && isFinite(s.taxtotal)) { taxEl.textContent = fmt(s.taxtotal - (s.taxonshipping || 0) + qTax); }
			if (totalEl && isFinite(s.total)) { totalEl.textContent = fmt(s.total - sc - (s.taxonshipping || 0) + q + qTax); }
		} else {
			shipEl.textContent = COPY.atCheckout;
			if (taxEl && isFinite(s.taxtotal)) { taxEl.textContent = fmt(s.taxtotal - (s.taxonshipping || 0)); }
			if (totalEl && isFinite(s.total)) { totalEl.textContent = fmt(s.total - sc - (s.taxonshipping || 0)); }
		}
	}

	function cartNeedsPaint() {
		var shipEl = document.querySelector(SEL.cartShipping);
		if (!shipEl) { return false; }
		var st = cartModelState();
		if (!st || !st.wwexish) { return false; }        // 1.8.0 — see paintCartSummary
		if (state.lastStatus === 'no_shippable_items') { return false; }   // 1.8.1
		var opt = state.quotes && state.quotes.options && state.quotes.options[0];
		var want = opt ? fmt(opt.amount) : COPY.atCheckout;
		return shipEl.textContent.trim() !== want;
	}

	// The order summary only ever carries OUR numbers while a WWEX method is selected
	// (1.2.3, KT rule: "shipping should not be charged for customer pickup" — a shopper on a
	// pickup method must see the native Free/zero summary, not the freight quote). Needs-paint
	// is therefore: WWEX selected AND the summary shipping line not showing the quote. When a
	// pickup is selected we never write the summary, and SCA's own re-render on method change
	// restores the native display.
	function summaryNeedsPaint() {
		if (!wwexMethodSelected()) { return false; }
		var opt = state.quotes && state.quotes.options && state.quotes.options[0];
		if (!opt) { return false; }
		var ship = document.querySelector(SEL.summaryShipping);
		return !!ship && ship.textContent.trim() !== fmt(opt.amount);
	}

	// 1.6.0 — coalesce keystrokes. CONFIG.REQUOTE_DEBOUNCE_MS has been declared since 1.0 and
	// was never referenced: typing a city fired one rate request per matching keystroke. The
	// pending paint now happens at the call site, immediately, so the UI still reacts at once
	// while the request itself waits for typing to settle.
	function requestQuotes(cart, dest, cb) {
		if (state.inFlight) { return; }
		if (state.requoteTimer) { clearTimeout(state.requoteTimer); }
		state.requoteTimer = setTimeout(function () {
			state.requoteTimer = null;
			sendQuote(cart, dest, cb);
		}, CONFIG.REQUOTE_DEBOUNCE_MS);
	}

	// 1.8.1 — takes the SAME dest object the key was built from. Until now this re-read city,
	// state and residential straight from the DOM, and after 1.6.0 it did so 400ms later, inside
	// the debounce — squarely inside the SCA re-render window those very reads were made sticky to
	// survive. A request landing mid-render posted an empty city and state, and shopFlow answers
	// that with "Destination/Origin Locality is required" and no offers: an LTL cart silently lost
	// its rate for a destination that had not changed, with state.lastKey already latched on the
	// good key so it stayed lost until the retries ran out. Residential had the same split, which
	// made the 1.7.0 default post F while the key said T.
	function sendQuote(cart, dest, cb) {
		if (state.inFlight) { return; }
		state.inFlight = true;
		// Preflight-free simple request (text/plain, no custom headers) — same CORS pattern as
		// the other sea_* Suitelets.
		var xhr = new XMLHttpRequest();
		xhr.open('POST', state.serviceUrl, true);
		xhr.setRequestHeader('Content-Type', 'text/plain');
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) { return; }
			state.inFlight = false;
			var out = null;
			try { out = JSON.parse(xhr.responseText); } catch (e) { out = null; }
			cb(out && out.status === 'ok' ? out : (out || { status: 'error' }));
		};
		xhr.send(JSON.stringify({
			destination: {
				zip: dest.zip,
				country: 'US',
				residential: dest.resi,
				// city + state are REQUIRED for freight. shopFlow answers a bare zip with
				// "Destination/Origin Locality is required" and returns nothing, so an LTL cart
				// silently loses its rate without these.
				city: dest.city,
				state: dest.state,
				line1: dest.line1,
				company: dest.company
			},
			items: cart,
			email: readEmail(),
			// 1.10.0 — handling basis. The engine folds pct × this into options[0].amount; the
			// UE re-derives it from the order at submit, so this only ever shapes the DISPLAY.
			subtotal: readSubtotal()
		}));
	}

	// 1.10.0 — merchandise subtotal from the LiveOrder model: goods net of promo, before tax and
	// shipping. Mirrors UE_sea_wwex_shipcost.merchandiseSubtotal (subtotal − |discounttotal|).
	// Unreadable model → 0 → the quote carries no handling; the UE still adds the real handling.
	function readSubtotal() {
		try {
			var LO = require('LiveOrder.Model');
			var inst = LO && LO.getInstance && LO.getInstance();
			var sum = inst && inst.get && inst.get('summary');
			if (!sum) { return 0; }
			var sub = Number(sum.subtotal) || 0;
			var disc = Math.abs(Number(sum.discounttotal) || 0);
			return Math.max(0, Math.round((sub - disc) * 100) / 100);
		} catch (e) { return 0; }
	}

	// --- painting (selectors measured 2026-08-24 — see SEL) ----------------------------------

	function paint(step, result) {
		// 1.2.4: step may be null (review page has no shipmethod module); row work is skipped,
		// the review select and summary are handled on their own. 1.3.0 adds the cart page.
		paintReviewSelect(result);
		paintCartSummary(result);
		if (!step) {
			// 1.10.5 — a resolved request ends the pending cycle HERE too. Without this the Review step
			// (no shipmethod module) left state.pending true until the 25 s watchdog, and 1.10.4's
			// pending hold kept "Calculating…" and the native "Free!" select text up for all of it.
			state.pending = false;
			clearPendingTimer();
			clearBootTimer();
			setRepricing(false);
			if (result.status === 'ok') {
				state.mode = (result.mode === 'ltl' || result.mode === 'parcel') ? result.mode : state.mode;
				state.rowCopy = null;
			}
			if (result.status === 'ok' && wwexMethodSelected()) { paintSummary(result); }
			else if (result.status !== 'ok') { neutralizeSummary(); }
			return;
		}
		if (result.status !== 'ok') {
			// 1.5.0 — a resolved request always ends the pending window; each branch below then
			// decides row visibility for itself.
			state.pending = false;
			clearPendingTimer();
			clearBootTimer();
			setRepricing(false);
			neutralizeSummary();
			try { console.warn('[WwexRates] quote failed:', result.status); } catch (e) {}
			// Nothing in the cart ships (warranty-only order). Not a data failure — there is
			// simply nothing to rate, so leave the native table alone even under STRICT rather
			// than sending a customer to contact-us for an order with no shipment.
			if (result.status === 'no_shippable_items') {
				setArm('hide-both');
				eachWwexRow(step, function (row) {
					row.removeAttribute('data-sea-wwex-pending');
					row.style.display = 'none';
				});
				return;
			}
			if (CONFIG.STRICT) {
				// Post-transition: no self-serve rate without a real quote. GUARD (added after
				// the 2026-08-24 measurement): only suppress the legacy table when WWEX rows
				// actually exist to stand in for it — pre-cutover (12310/12311 not web-displayed)
				// hiding 12007 would leave the shopper NO shippable method at all.
				// 1.5.0 — paintPending may have hidden these; STRICT is a FAIL-VISIBLE path, so put
				// them back before writing the copy the shopper is meant to read. revealPendingRows
				// also drops the arm class, so the CSS stops hiding them too (1.5.1).
				revealPendingRows(null);
				var msg = result.status === 'missing_item_data' ? COPY.missingData : COPY.unavailable;
				var painted = eachWwexRow(step, function (row) { setPrice(row, null, msg); });
				if (painted > 0) { setRowVisible(step, CONFIG.LEGACY_SHIP_ITEM_ID, false); }
				// 1.10.1 — and keep it there. A re-render used to put the native "Free!" back.
				state.rowCopy = msg;
			} else {
				// TRANSITION HYBRID: hide the WWEX rows, let the native legacy table stand.
				// Known cost, accepted 2026-08-10: until an item's data is populated, a bulky
				// cart still rides the table — the fix is populating that item, bulk-first.
				setArm('hide-both');
				eachWwexRow(step, function (row) {
					row.removeAttribute('data-sea-wwex-pending');
					row.style.display = 'none';
				});
			}
			return;
		}
		state.quotes = result;
		state.rowCopy = null;   // 1.10.1 — a priced row is painted from the quote from here on
		// 1.5.0 — from here visibility is decided by the quote's mode, not by paintPending. The
		// matching row is explicitly re-shown (it is display:none while pending) and the other
		// stays hidden: one WWEX option on screen, ever.
		state.pending = false;
		clearPendingTimer();
		clearBootTimer();
		// 1.5.1 — the arm class is the real gate; the inline styles below are belt-and-braces for
		// rows already on screen. Set from result.mode so any row the wizard renders from here on
		// is correct at first paint, re-render or not.
		state.mode = (result.mode === 'ltl' || result.mode === 'parcel') ? result.mode : null;
		setRepricing(false);
		setArm(state.mode);
		var revealedId = null;
		var paintedOk = eachWwexRow(step, function (row, kind) {
			row.removeAttribute('data-sea-wwex-pending');
			var opt = pickOption(result, kind);
			if (opt) {
				row.style.display = '';
				setPrice(row, opt.amount, null);
				revealedId = (kind === 'parcel') ? CONFIG.SHIP_ITEM_IDS.parcel : CONFIG.SHIP_ITEM_IDS.ltl;
			} else {
				row.style.display = 'none';
			}
		});
		// The shopper can be sitting on the row we just hid — the wizard's own default lands on
		// whichever WWEX row rendered first, before any mode was known. Move it onto the live one.
		// Only ever moves BETWEEN the two WWEX rows: a pickup or legacy selection is left alone.
		if (revealedId) {
			var selNow = selectedShipMethodId();
			var onOtherWwex = (selNow === CONFIG.SHIP_ITEM_IDS.parcel || selNow === CONFIG.SHIP_ITEM_IDS.ltl) &&
			                  selNow !== revealedId;
			if (onOtherWwex) { selectRow(step, revealedId); }
		}
		// A real quote exists — the cheap legacy table is not an option for this cart. Same
		// pre-cutover guard as above: never remove 12007 unless a WWEX row replaced it.
		if (paintedOk > 0) {
			setRowVisible(step, CONFIG.LEGACY_SHIP_ITEM_ID, false);
			// 1.2.3: the summary carries the freight quote ONLY while a WWEX method is the
			// selected one. A shopper on Customer Pickup sees the native Free/zero summary —
			// shipping is never shown as charged for pickup.
			if (wwexMethodSelected()) { paintSummary(result); }
		}
	}

	function setRowVisible(step, shipItemId, visible) {
		if (!shipItemId) { return; }
		var rows = step.querySelectorAll(SEL.methodRow);
		for (var i = 0; i < rows.length; i++) {
			if (rows[i].getAttribute(SEL.methodRowIdAttr) === shipItemId) {
				rows[i].style.display = visible ? '' : 'none';
			}
		}
	}

	// 1.5.1 — the arming stylesheet. One rule set, driven by a single class on <html>:
	//   sea-wwex-pending    both WWEX rows hidden (quote in flight / not yet answered)
	//   sea-wwex-mode-ltl   parcel row hidden      sea-wwex-mode-parcel  LTL row hidden
	//   sea-wwex-hide-both  both hidden (nothing shippable / pre-cutover hybrid)
	//   (no class)          nothing hidden — STRICT fail-visible, and the stranding guards
	// The REVEALED row is never given a rule, so it keeps whatever display the theme gives it —
	// no need to guess flex/block, which is why this is a class on the root and not inline style.
	function normTxt(v) { return String(v == null ? '' : v).trim().toUpperCase().replace(/\s+/g, ' '); }

	// 1.6.0 — STICKY DESTINATION READS. The old key was built by re-reading the DOM on every
	// mutation: zip from input[name="zip"], city from [name="city"], residential from the
	// checkbox, each with a fall-through to the LiveOrder model when the element is missing.
	// SCA re-renders the address module on ANY field change — phone included — and during that
	// re-render those inputs are briefly absent, so the reads fell through to the model and back
	// again. The key flipped, and a phone edit re-quoted a destination that had not changed.
	// Now each component keeps its last KNOWN-GOOD value: a blank or unreadable field reuses what
	// we already had instead of rewriting the key. Clearing the zip to retype it therefore does
	// not re-quote until a full valid zip is entered — which is the behaviour we want anyway.
	function sticky(field, cur) {
		if (cur) { state.sticky[field] = cur; return cur; }
		return state.sticky[field] || '';
	}

	// 1.7.0 — default the residential checkbox ON for a NEW address only.
	//
	// Three rules, each there for a reason:
	//   * A SAVED address is never touched. selectedAddress() returns the model's chosen address;
	//     if it has an internalid the shopper already has a value on file and flipping it would
	//     silently rewrite a commercial address to residential.
	//   * The shopper's own change wins forever after (state.resiUserTouched), so unchecking it
	//     sticks even though the wizard re-renders this form on every keystroke elsewhere.
	//   * The marker attribute is per ELEMENT, not a global "done" flag: SCA replaces the form
	//     node on re-render, and a fresh unchecked checkbox should get the default again — but
	//     only if the shopper has not spoken.
	// Called at the very top of onDomChange so the value is in place BEFORE the key is built,
	// otherwise the first quote goes out with F and a second one immediately follows with T.
	function applyResidentialDefault() {
		if (!CONFIG.RESIDENTIAL_DEFAULT || state.resiUserTouched) { return; }
		var box = null;
		try { box = shipInput('isresidential'); } catch (e) { return; }
		if (!box || box.getAttribute('data-sea-wwex-resi') === '1') { return; }
		box.setAttribute('data-sea-wwex-resi', '1');
		if (box.checked) { return; }
		var addr = selectedAddress();
		if (addr && addr.internalid) { return; }        // saved address — its own value stands
		box.checked = true;
		state.sticky.resi = 'T';
		// The theme serializes this form on submit, so setting .checked is enough on its own; the
		// events are for any view listening on the input, and are dispatched non-cancelably so a
		// handler cannot bounce the box back.
		try {
			box.dispatchEvent(new Event('input', { bubbles: true }));
			box.dispatchEvent(new Event('change', { bubbles: true }));
		} catch (e2) {
			try { var ev = document.createEvent('HTMLEvents'); ev.initEvent('change', true, false); box.dispatchEvent(ev); } catch (e3) {}
		}
		try { console.info('[WwexRates] residential defaulted on for a new address'); } catch (e4) {}
	}

	function readDest() {
		var z = readZip();
		// ZIP+4 never changes a rate here — normalise to 5 so a +4 arriving late is not a new key.
		var zip = sticky('zip', z ? String(z).slice(0, 5) : '');
		var resi;
		var box = null;
		try { box = shipInput('isresidential'); } catch (e) { box = null; }
		if (box) { resi = box.checked ? 'T' : 'F'; state.sticky.resi = resi; }
		else { resi = state.sticky.resi || readResidential(); }
		// 1.8.1 — sticky the RAW field values, not the normalised ones. The normalisation exists to
		// stop cosmetic differences rewriting the cache key; it has no business reaching WWEX, and
		// line1/company are stickied too so the request never posts a half-rendered address.
		return {
			zip: zip || null,
			city: sticky('city', String(readAddrField('city') || '').trim()),
			state: sticky('state', String(readAddrField('state') || '').trim()),
			line1: sticky('line1', String(readAddrField('addr1') || '').trim()),
			company: sticky('company', String(readAddrField('company') || '').trim()),
			resi: resi
		};
	}

	// 1.9.0 — say so on the field itself. Deliberately does NOT touch the wizard's own
	// validation or block Next: that is the theme's job, and hijacking submit from here would put
	// this extension in charge of whether an order can proceed. This marks the input invalid for
	// assistive tech and puts one line of copy beside it, so a mistyped zip reads as a mistake
	// rather than as free shipping. Only ever touches the SHIPPING zip field.
	function markZip() {
		if (!CONFIG.ZIP_ENFORCE) { return; }
		try {
			var el = shipInput('zip');
			if (!el) { return; }
			var raw = String(el.value || '').trim();
			// Empty, or still being typed toward 5 digits: not an error yet.
			var partial = raw === '' || /^\d{0,4}$/.test(raw);
			var bad = !partial && !CONFIG.ZIP_RE.test(raw);
			var id = 'sea-wwex-zip-msg';
			var msg = document.getElementById(id);
			if (bad) {
				el.setAttribute('aria-invalid', 'true');
				if (!msg) {
					msg = document.createElement('div');
					msg.id = id;
					msg.setAttribute('role', 'alert');
					msg.style.cssText = 'font-size:13px;margin-top:4px;color:#b3261e';
					msg.textContent = COPY.zipInvalid;
					if (el.parentNode) { el.parentNode.appendChild(msg); }
				}
			} else {
				el.removeAttribute('aria-invalid');
				if (msg && msg.parentNode) { msg.parentNode.removeChild(msg); }
			}
		} catch (e) {}
	}

	function setRepricing(on) {
		state.repricing = !!on;
		if (!state.armed) { return; }
		try { document.documentElement.classList[on ? 'add' : 'remove']('sea-wwex-repricing'); } catch (e) {}
	}

	function injectArmCss() {
		if (document.getElementById('sea-wwex-arm-css')) { return; }
		var OPT = SEL.methodRow, A = SEL.methodRowIdAttr;
		var P = '[' + A + '="' + CONFIG.SHIP_ITEM_IDS.parcel + '"]';
		var L = '[' + A + '="' + CONFIG.SHIP_ITEM_IDS.ltl + '"]';
		var css = [
			'html.sea-wwex-pending ' + OPT + P,
			'html.sea-wwex-pending ' + OPT + L,
			'html.sea-wwex-hide-both ' + OPT + P,
			'html.sea-wwex-hide-both ' + OPT + L,
			'html.sea-wwex-mode-parcel ' + OPT + L,
			'html.sea-wwex-mode-ltl ' + OPT + P
		].join(',') + '{display:none !important;}';
		// 1.6.0 — SPINNER. While pending the panel is genuinely empty: the pickups came off the
		// web store and 12007 is not web-displayed, so hiding both WWEX rows leaves a bare box.
		// ::before is the spinner and ::after the label; every row between them is hidden, so the
		// two render as one loading block. currentColor with a transparent top border means no
		// assumption about the theme's palette.
		var MOD = SEL.deliveryStep, PRICE = SEL.methodPrice;
		css += '@keyframes sea-wwex-spin{to{transform:rotate(360deg)}}' +
			'html.sea-wwex-pending ' + MOD + '::before{content:"";display:block;width:22px;' +
			'height:22px;margin:18px auto 8px;border:2px solid currentColor;' +
			'border-top-color:transparent;border-radius:50%;opacity:.45;' +
			'animation:sea-wwex-spin .8s linear infinite}' +
			'html.sea-wwex-pending ' + MOD + '::after{content:' + JSON.stringify(COPY.quoting) +
			';display:block;text-align:center;padding-bottom:18px;opacity:.7}' +
			// 1.10.2 — same block, longer-wait wording
			'html.sea-wwex-pending.sea-wwex-slow ' + MOD + '::after{content:' +
			JSON.stringify(COPY.quotingSlow) + '}' +
			'html.sea-wwex-repricing ' + PRICE + '::before{content:"";display:inline-block;' +
			'width:12px;height:12px;margin-right:6px;vertical-align:-2px;border:2px solid currentColor;' +
			'border-top-color:transparent;border-radius:50%;opacity:.45;' +
			'animation:sea-wwex-spin .8s linear infinite}' +
			'@media (prefers-reduced-motion:reduce){html.sea-wwex-pending ' + MOD + '::before,' +
			'html.sea-wwex-repricing ' + PRICE + '::before{animation:none}}';
		try {
			var el = document.createElement('style');
			el.id = 'sea-wwex-arm-css';
			el.appendChild(document.createTextNode(css));
			(document.head || document.documentElement).appendChild(el);
			state.armed = true;
		} catch (e) {
			try { console.warn('[WwexRates] could not inject arm css', e); } catch (e2) {}
		}
	}

	var ARM_CLASSES = ['sea-wwex-pending', 'sea-wwex-mode-parcel', 'sea-wwex-mode-ltl', 'sea-wwex-hide-both'];

	// mode: 'pending' | 'parcel' | 'ltl' | 'hide-both' | null (null hides nothing).
	function setArm(mode) {
		if (!state.armed) { return; }
		try {
			var root = document.documentElement, i;
			for (i = 0; i < ARM_CLASSES.length; i++) { root.classList.remove(ARM_CLASSES[i]); }
			if (mode === 'pending') { root.classList.add('sea-wwex-pending'); }
			else if (mode === 'parcel') { root.classList.add('sea-wwex-mode-parcel'); }
			else if (mode === 'ltl') { root.classList.add('sea-wwex-mode-ltl'); }
			else if (mode === 'hide-both') { root.classList.add('sea-wwex-hide-both'); }
			if (mode !== null) { root.classList.remove('sea-wwex-repricing'); state.repricing = false; }
			if (mode !== 'pending') { root.classList.remove('sea-wwex-slow'); }   // 1.10.2
		} catch (e) {}
	}

	// 1.5.0 — the pending window is the bug. Hide both WWEX rows while the quote is in flight;
	// paint() reveals exactly one. The price text is still set, so a row brought back by the
	// watchdog (or by a theme that overrides display) reads as pending rather than as a price.
	// scope: 'full'    — mode unknown, hide both rows and show the spinner block in the panel.
	//        'reprice' — same cart, mode already known: the one correct row STAYS on screen and
	//                    spins in its price cell. No blank panel for a destination edit.
	function paintPending(scope) {
		state.rowCopy = null;   // 1.10.1 — a rating cycle owns the rows; stop holding old copy
		var reprice = (scope === 'reprice' && !!state.mode && !!state.quotes);   // 1.10.4 — see onDomChange
		var step = document.querySelector(SEL.deliveryStep);
		if (step) {
			eachWwexRow(step, function (row, kind) {
				if (reprice && kind !== state.mode) { return; }   // loser stays hidden by the arm
				setPrice(row, null, COPY.quoting);
				if (CONFIG.PENDING_HIDE && !reprice) {
					row.setAttribute('data-sea-wwex-pending', '1');
					row.style.display = 'none';
				}
			});
		}
		if (!CONFIG.PENDING_HIDE) { return; }
		clearBootTimer();          // 1.8.1 — a real cycle has started; the boot guard steps aside
		injectArmCss();
		if (reprice) { setRepricing(true); } else { setArm('pending'); }
		state.pending = true;
		try { repaintReviewPending(); } catch (eRv) {}   // 1.10.5 — Review: "Calculating…", never "Free!"
		clearPendingTimer();
		// 1.10.2 — the summary says a number is coming, not "At checkout". Written directly:
		// requestQuotes() has not armed requoteTimer yet, so noQuoteSummaryText() would still say
		// "At checkout" at this instant. Re-renders during the request go through neutralizeSummary.
		// 1.10.4 — re-price too: the summary's old number is exactly the stale price we must not show.
		try {
			var sumEl = wwexMethodSelected() && document.querySelector(SEL.summaryShipping);
			if (sumEl && sumEl.textContent.trim() !== COPY.calculating) { sumEl.textContent = COPY.calculating; }
		} catch (eSum) {}
		if (!reprice) {
			state.slowTimer = setTimeout(function () {
				state.slowTimer = null;
				if (!state.pending || !state.armed) { return; }
				try { document.documentElement.classList.add('sea-wwex-slow'); } catch (eSlow) {}
			}, CONFIG.PENDING_SLOW_MS);
		}
		state.pendingTimer = setTimeout(function () {
			if (!state.pending) { return; }
			try {
				console.warn('[WwexRates] no quote after ' + CONFIG.PENDING_MAX_MS +
				             'ms — revealing rows so the cart is not left unshippable');
			} catch (e) {}
			if (state.repricing) {
				// Re-pricing: the row is still up showing "getting rates". Never fall back to the
				// previous number — a stale price displayed is the one outcome this project exists
				// to prevent — so say so in the price cell and stop the spinner.
				setRepricing(false);
				var st2 = document.querySelector(SEL.deliveryStep);
				if (st2) { eachWwexRow(st2, function (row) { setPrice(row, null, COPY.unavailable); }); }
				state.pending = false;
				state.rowCopy = COPY.unavailable;   // 1.10.1
				return;
			}
			revealPendingRows(COPY.unavailable);
			state.rowCopy = COPY.unavailable;       // 1.10.1
		}, CONFIG.PENDING_MAX_MS);
	}

	function clearPendingTimer() {
		if (state.pendingTimer) { clearTimeout(state.pendingTimer); state.pendingTimer = null; }
		// 1.10.2 — the slow label lives and dies with the pending cycle
		if (state.slowTimer) { clearTimeout(state.slowTimer); state.slowTimer = null; }
		try { document.documentElement.classList.remove('sea-wwex-slow'); } catch (e) {}
	}

	// 1.8.1 — the boot watchdog exists only to cover the gap between arming at boot and the FIRST
	// quote. Once a rating cycle is genuinely under way, the 12s pending watchdog owns the
	// outcome and this one must get out of the way. Left running it did real damage: a shopper
	// who spent more than 15s on the address form had setArm(null) + revealPendingRows(null)
	// fired into an in-flight quote, which cleared state.pending AND killed pendingTimer — so
	// both rows came back at the native price and the watchdog that would have written
	// "Rate unavailable" was gone. It also wiped a deliberate setArm('hide-both') from the
	// no_shippable_items path: the existing rows survived on their inline display:none, but the
	// next wizard re-render painted two fresh rows at $0.00.
	function clearBootTimer() {
		if (state.bootTimer) { clearTimeout(state.bootTimer); state.bootTimer = null; }
	}

	// Undo the pending hide. `text`, when given, replaces the price column — the watchdog uses
	// it so a revealed row never shows the native flat rate as if it were a quote.
	function revealPendingRows(text) {
		state.pending = false;
		clearPendingTimer();
		setArm(null);
		setRepricing(false);
		var step = document.querySelector(SEL.deliveryStep);
		if (!step) { return; }
		eachWwexRow(step, function (row) {
			if (row.getAttribute('data-sea-wwex-pending') !== '1') { return; }
			row.removeAttribute('data-sea-wwex-pending');
			row.style.display = '';
			if (text) { setPrice(row, null, text); }
		});
	}

	// Returns how many WWEX rows exist, so callers can tell "painted the rows" apart from "the
	// WWEX ship items are not web-displayed" — the pre-cutover state, when 12310/12311 were
	// unticked. That state is history (they went live 2026-08-25), but the count still guards the
	// 12007 suppression below, so it stays.
	function eachWwexRow(step, fn) {
		var count = 0;
		var rows = step.querySelectorAll(SEL.methodRow);
		for (var i = 0; i < rows.length; i++) {
			var id = rows[i].getAttribute(SEL.methodRowIdAttr);
			if (id === CONFIG.SHIP_ITEM_IDS.parcel) { count++; fn(rows[i], 'parcel'); }
			else if (id === CONFIG.SHIP_ITEM_IDS.ltl) { count++; fn(rows[i], 'ltl'); }
		}
		return count;
	}

	function pickOption(result, kind) {
		if (result.mode !== kind) { return null; }        // LTL-forced cart hides the parcel row
		return result.options && result.options[0] ? result.options[0] : null;
	}

	function setPrice(row, amount, text) {
		var el = row.querySelector(SEL.methodPrice);
		if (!el) { return; }                              // fail visible
		el.textContent = amount !== null ? fmt(amount) : text;
	}

	// 1.8.0 — when a WWEX method is selected but no quote exists, the server has priced the order
	// with the ship item's flat rate. That is $0.00 today, so the summary reads free. Replace the
	// shipping line with the at-checkout wording rather than let a zero stand; the total is left
	// as the server computed it, because inventing one would be the same sin in the other
	// direction. A pickup selection is not ours and is untouched.
	function neutralizeSummary() {
		try {
			if (!wwexMethodSelected()) { return; }
			var el = document.querySelector(SEL.summaryShipping);
			var want = noQuoteSummaryText();
			if (el && el.textContent.trim() !== want) { el.textContent = want; }
		} catch (e) {}
	}

	// 1.10.2 — "Calculating…" while a rate request is queued or in flight and no quote exists;
	// "At checkout" otherwise. Keyed on the request itself, not state.pending, because the failure
	// path neutralises the summary before it clears pending — by then the request is over.
	// 1.10.4 — what the page shows while a rating cycle is pending. Full pending: rows are hidden by
	// the arm CSS (their text is irrelevant) and the summary reads "Calculating…". Re-price: the
	// mode row stays up with COPY.quoting in its price cell (the CSS spinner sits beside it) and the
	// summary reads "Calculating…". Never the previous quote, never the native $0.00.
	// 1.10.5 — the review <select> while a cycle is pending: the selected WWEX option reads
	// "Calculating…<label>", any other WWEX option is withdrawn. Never the native "Free!".
	function reviewPendingNeedsPaint() {
		var sel = document.querySelector(SEL.reviewSelect);
		if (!sel) { return false; }
		for (var i = 0; i < sel.options.length; i++) {
			var o = sel.options[i];
			if (o.value !== CONFIG.SHIP_ITEM_IDS.parcel && o.value !== CONFIG.SHIP_ITEM_IDS.ltl) { continue; }
			if (o.selected) { if (o.text !== COPY.calculating + optLabel(o)) { return true; } }
			else if (!o.hidden) { return true; }
		}
		return false;
	}

	function repaintReviewPending() {
		var sel = document.querySelector(SEL.reviewSelect);
		if (!sel) { return; }
		var i, o;
		for (i = 0; i < sel.options.length; i++) {
			o = sel.options[i];
			if (o.value === CONFIG.SHIP_ITEM_IDS.parcel || o.value === CONFIG.SHIP_ITEM_IDS.ltl) { optLabel(o); }
		}
		for (i = 0; i < sel.options.length; i++) {
			o = sel.options[i];
			if (o.value !== CONFIG.SHIP_ITEM_IDS.parcel && o.value !== CONFIG.SHIP_ITEM_IDS.ltl) { continue; }
			if (o.selected) {
				var want = COPY.calculating + optLabel(o);
				if (o.text !== want) { o.text = want; }
			} else if (!o.hidden) { o.hidden = true; o.disabled = true; }
		}
	}

	function pendingNeedsPaint(step) {
		if (!state.pending) { return false; }
		try {
			if (reviewPendingNeedsPaint()) { return true; }
			if (wwexMethodSelected()) {
				var el = document.querySelector(SEL.summaryShipping);
				if (el && el.textContent.trim() !== COPY.calculating) { return true; }
			}
			if (step && state.repricing && state.mode) {
				var need = false;
				eachWwexRow(step, function (row, kind) {
					if (kind !== state.mode) { return; }
					var pe = row.querySelector(SEL.methodPrice);
					if (pe && pe.textContent !== COPY.quoting) { need = true; }
				});
				if (need) { return true; }
			}
		} catch (e) {}
		return false;
	}

	function repaintPending(step) {
		try {
			repaintReviewPending();   // 1.10.5
			if (wwexMethodSelected()) {
				var el = document.querySelector(SEL.summaryShipping);
				if (el && el.textContent.trim() !== COPY.calculating) { el.textContent = COPY.calculating; }
			}
			if (step && state.repricing && state.mode) {
				eachWwexRow(step, function (row, kind) {
					if (kind !== state.mode) { return; }
					var pe = row.querySelector(SEL.methodPrice);
					if (pe && pe.textContent !== COPY.quoting) { setPrice(row, null, COPY.quoting); }
				});
			}
		} catch (e) {}
	}

	// 1.10.2 — cheap check for the un-debounced observer: one radio lookup, one summary lookup.
	function noQuoteSummaryNeedsPaint() {
		try {
			if (state.quotes || !wwexMethodSelected()) { return false; }
			var el = document.querySelector(SEL.summaryShipping);
			return !!el && el.textContent.trim() !== noQuoteSummaryText();
		} catch (e) { return false; }
	}

	function noQuoteSummaryText() {
		return (!state.quotes && (state.inFlight || state.requoteTimer)) ? COPY.calculating : COPY.atCheckout;
	}

	// DISPLAY-only summary update (the UE sets the real cost at submit).
	//
	// 1.2.2 — the delta-from-DOM version showed $37.80 on a $16.74 order. MEASURED at cutover:
	// once the shopper SELECTS the WWEX method, the server prices the order with the ship item's
	// native $250 fallback AND taxes it ($21.88 of tax on phantom shipping); adjusting only the
	// shipping number left that tax inside the displayed total. The authoritative fix reads the
	// LiveOrder model's summary — server state, immune to our own DOM writes, and it carries
	// taxonshipping as its OWN field (measured: {subtotal:6.04, taxtotal:22.41, shippingcost:250,
	// taxonshipping:21.88, total:278.45}) — and rebuilds the display as:
	//     total − shippingcost − taxonshipping + quote + quote×(taxonshipping/shippingcost)
	// which keeps every other component (discounts, handling, goods tax) untouched inside the
	// server's own total. The tax line is adjusted by the same substitution. When no method is
	// selected yet (shippingcost 0, taxonshipping 0) the same formula displays subtotal-tax
	// + untaxed quote — matching the native page until the server itself taxes a selection.
	// Every parse is guarded: if the model is unreadable, fall back to the old DOM delta; if
	// that fails too, touch nothing — a stale number beats an invented one.
	function paintSummary(result) {
		var opt = result.options && result.options[0];
		if (!opt) { return; }
		var q = Number(opt.amount);
		var shipEl = document.querySelector(SEL.summaryShipping);
		var taxEl = document.querySelector(SEL.summaryTax);
		var totalEl = document.querySelector(SEL.summaryTotal);
		// Capture the DOM numbers BEFORE overwriting the shipping span — the fallback path
		// depends on the pre-paint values.
		var oldShip = shipEl ? parseFloat(String(shipEl.textContent).replace(/[^0-9.]/g, '')) : NaN;
		var oldTotal = totalEl ? parseFloat(String(totalEl.textContent).replace(/[^0-9.]/g, '')) : NaN;
		if (shipEl) { shipEl.textContent = fmt(q); }

		var s = null;
		try {
			var LO = require('LiveOrder.Model');
			var inst = LO && LO.getInstance && LO.getInstance();
			s = inst && inst.get && inst.get('summary');
		} catch (e) { s = null; }

		if (s && isFinite(s.total) && isFinite(s.shippingcost) && isFinite(s.taxonshipping)) {
			var taxRate = s.shippingcost > 0 ? (s.taxonshipping / s.shippingcost) : 0;
			var qTax = Math.round(q * taxRate * 100) / 100;
			if (totalEl) { totalEl.textContent = fmt(s.total - s.shippingcost - s.taxonshipping + q + qTax); }
			if (taxEl && isFinite(s.taxtotal)) { taxEl.textContent = fmt(s.taxtotal - s.taxonshipping + qTax); }
			return;
		}

		// Fallback: DOM delta on the shipping number alone (pre-1.2.2 behavior).
		if (totalEl && !isNaN(oldShip) && !isNaN(oldTotal)) {
			totalEl.textContent = fmt(oldTotal - oldShip + q);
		}
	}

	// --- reads (sources measured on the live test checkout, 2026-08-24) ----------------------

	// S2 RESOLVED, measured 2026-08-24. Two sources, in preference order:
	//   1. LiveOrder.Model — require('LiveOrder.Model').getInstance() works in the checkout app
	//      (measured), and it is the LIVE cart, current across mid-checkout edits.
	//   2. SC.ENVIRONMENT.CART — the bootstrap payload. Its lines[].internalid is the LINE id
	//      (measured: "item6480set260" — NOT an item id; the 1.0.x code sent this and every
	//      lookup would have missed); the ITEM id is lines[].item.internalid (measured: 6480).
	//      Bootstrap data can go stale after cart edits, hence fallback only.
	// --- pickup guard (1.4.0) -----------------------------------------------------------------
	//
	// Audit S1/S2 fix. Two jobs, both driven off ONE data source:
	//   1. an ineligible pickup cannot be chosen
	//   2. a pickup is never the unearned default
	//
	// THE DATA SOURCE, measured on www 2026-08-25: the storefront's own public item API already
	// returns per-location stock, so this needs no Suitelet, no script record and no deployment
	// context filtering to get wrong (the thing that cost every web order its freight until 8/24).
	//     GET /api/items?id=483,664&fieldset=details
	//     483 → quantityonhand_detail {"quantityonhand":6,"locations":[{"internalid":1,"quantityonhand":6}]}
	//     664 → quantityonhand_detail {"quantityonhand":7,"locations":[{"internalid":3,"quantityonhand":7}]}
	//
	// KNOWN AND ACCEPTED: that field is ON HAND, not AVAILABLE — quantity committed to other
	// orders is not deducted, so this can call a line collectable that is really spoken for. It is
	// a filter, not an authority. UE_sea_wwex_shipcost v0.6 re-checks the true
	// locationquantityavailable at submit and has the final word.
	//
	// Dry-run verified against live www data 2026-08-25 before any of this was written:
	//   483 alone            → Greenville ok, Newnan/Texas blocked
	//   483 + 664            → all three blocked (664 is Catoosa-only)
	//   483 x9 (6 on hand)   → all three blocked (quantity respected, not just presence)
	//   4010 warranty alone  → all three ok (no locations = nothing to collect)

	function runPickupGuard(step, cart) {
		var key = cart.map(function (l) { return l.id + ':' + l.qty; }).sort().join(',');
		if (key !== state.stockKey) {
			if (state.stockInFlight) { return; }        // key moved mid-request: next DOM tick
			state.stockKey = key;
			state.stock = null;
			state.defaultMoved = false;                 // a new cart earns a fresh default
			paintPickupPending(step);
			fetchStock(cart, function (stock) {
				state.stock = stock;                    // null = indeterminate, see below
				if (!stock) {
					// 1.4.1 — indeterminate is not permanent. 1.4.0 cached the null under this cart
					// key and never tried again, so one blip disabled the guard for the whole cart.
					// Clearing the key lets the next DOM tick retry; after two failures we stop and
					// fail open (rows keep whatever they last showed; the UE backstop still flags
					// the order). Bounded so a genuinely broken API is not hammered.
					state.stockTries = (state.stockTries || 0) + 1;
					if (state.stockTries <= 2) { state.stockKey = null; }
					return;
				}
				state.stockTries = 0;
				var s = document.querySelector(SEL.deliveryStep);
				if (s) { applyPickupGuard(s, cart); }
			});
			return;
		}
		if (!state.stock) { return; }
		if (pickupRowsNeedPaint(step, cart)) { applyPickupGuard(step, cart); return; }
		// 1.4.1 — the rows can be correctly marked while the SELECTION is still wrong, so row
		// marking cannot be the readiness test for it. MEASURED on www 2026-08-25: the stock fetch
		// is one fast /api/items call and beats the WWEX rating call, so the first paint happens
		// while the WWEX row has no price yet — firstSelectableRatedRow finds no target, the
		// selection stays on the blocked pickup, and pickupRowsNeedPaint then says "nothing to do"
		// forever after. Re-check the selection on every tick instead. Cheap and idempotent: once
		// the selected method is not a pickup, enforcePickupSelection returns on its first line.
		enforcePickupSelection(step, pickupEligibility(cart, state.stock));
	}

	// One same-origin GET. Returns { itemId: { locationId: qtyOnHand } }, or null when the answer
	// is incomplete — a short page, an unexpected shape, a network failure. null means
	// INDETERMINATE and the rows are left exactly as the native page rendered them: better a
	// pickup we failed to block (the UE still catches it) than a pickup we wrongly blocked.
	function fetchStock(cart, cb) {
		state.stockInFlight = true;
		var ids = cart.map(function (l) { return l.id; });
		var url = '/api/items?id=' + ids.join(',') + '&fieldset=details&limit=' + Math.max(ids.length, 1);
		var xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.setRequestHeader('Accept', 'application/json');
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) { return; }
			state.stockInFlight = false;
			var out = null;
			try {
				var j = JSON.parse(xhr.responseText);
				var items = j && j.items;
				// A short page means the API paged us; we cannot tell "not stocked there" from
				// "not in this response", so the whole answer is indeterminate.
				if (items && items.length >= ids.length) {
					out = {};
					for (var i = 0; i < items.length; i++) {
						var it = items[i];
						var map = {};
						var d = it.quantityonhand_detail;
						var locs = d && d.locations;
						if (locs && locs.length) {
							for (var k = 0; k < locs.length; k++) {
								map[String(locs[k].internalid)] = Number(locs[k].quantityonhand) || 0;
							}
						}
						out[String(it.internalid)] = map;
					}
				}
			} catch (e) { out = null; }
			if (!out) {
				try { console.warn('[WwexRates] pickup guard: stock indeterminate, rows left native'); } catch (e2) {}
			}
			cb(out);
		};
		xhr.onerror = function () { state.stockInFlight = false; cb(null); };
		xhr.send();
	}

	// { shipItemId: { ok: bool, missing: [{id, qty, have}] } } for every web-displayed pickup.
	// A NON-INVENTORY line (an extended warranty — no locations at all, measured: CCW, WE-*, WD-*)
	// is collectable anywhere and never blocks a pickup: there is nothing to collect.
	function pickupEligibility(cart, stock) {
		var out = {};
		for (var shipId in CONFIG.PICKUP_LOCATIONS) {
			if (!CONFIG.PICKUP_LOCATIONS.hasOwnProperty(shipId)) { continue; }
			var loc = String(CONFIG.PICKUP_LOCATIONS[shipId].location);
			var missing = [];
			for (var i = 0; i < cart.length; i++) {
				var line = cart[i];
				var map = stock[line.id];
				if (!map) { continue; }                                  // unknown item — do not block
				var anyLocation = false;
				for (var any in map) { if (map.hasOwnProperty(any)) { anyLocation = true; break; } }
				if (!anyLocation) { continue; }                          // non-inventory line
				var have = map[loc] || 0;
				if (have < (Number(line.qty) || 1)) { missing.push({ id: line.id, qty: line.qty, have: have }); }
			}
			out[shipId] = { ok: missing.length === 0, missing: missing };
		}
		return out;
	}

	function applyPickupGuard(step, cart) {
		if (!state.stock) { return; }                                    // indeterminate — leave native
		var elig = pickupEligibility(cart, state.stock);
		eachPickupRow(step, function (row, shipId) {
			var e = elig[shipId];
			var cfg = CONFIG.PICKUP_LOCATIONS[shipId];
			if (e.ok) {
				row.setAttribute('data-sea-pickup', 'ok');
				setRowEnabled(row, true);
				row.style.display = '';
				return;
			}
			row.setAttribute('data-sea-pickup', 'blocked');
			if (CONFIG.PICKUP_HIDE_INELIGIBLE) {
				row.style.display = 'none';
			} else {
				row.style.display = '';
				setRowEnabled(row, false);
				setPrice(row, null, COPY.pickupShort(cfg.label, e.missing.length));
			}
		});
		enforcePickupSelection(step, elig);
	}

	function paintPickupPending(step) {
		eachPickupRow(step, function (row) { setPrice(row, null, COPY.pickupChecking); });
	}

	// Cheap idempotence test, same shape as wwexRowsNeedPaint: true only when a row is not already
	// showing the state it should. Keeps the MutationObserver from looping on our own paints, and
	// repaints after SCA re-renders the option list.
	function pickupRowsNeedPaint(step, cart) {
		var elig = pickupEligibility(cart, state.stock);
		var need = false;
		eachPickupRow(step, function (row, shipId) {
			var want = elig[shipId].ok ? 'ok' : 'blocked';
			if (row.getAttribute('data-sea-pickup') !== want) { need = true; }
		});
		return need;
	}

	function eachPickupRow(step, fn) {
		var count = 0;
		var rows = step.querySelectorAll(SEL.methodRow);
		for (var i = 0; i < rows.length; i++) {
			var id = rows[i].getAttribute(SEL.methodRowIdAttr);
			if (id && CONFIG.PICKUP_LOCATIONS.hasOwnProperty(id)) { count++; fn(rows[i], id); }
		}
		return count;
	}

	function setRowEnabled(row, enabled) {
		var input = row.querySelector('input[name="delivery-options"]');
		if (input) { input.disabled = !enabled; }
		row.setAttribute('aria-disabled', enabled ? 'false' : 'true');
		row.style.opacity = enabled ? '' : '0.5';
		row.style.pointerEvents = enabled ? '' : 'none';
	}

	// Selection rules, in priority order:
	//   1. a BLOCKED method is never left selected — always move off it, even after the shopper
	//      chose it, because that selection is exactly the bug
	//   2. otherwise, move an unearned pre-selected pickup onto the rated row ONCE per cart, and
	//      never once the shopper has clicked a method themselves
	// With no eligible target (unquotable cart, every pickup blocked) the selection is left alone
	// and the UE's [PICKUP SPLIT] flag catches it — silently clearing the method would break
	// Continue and strand the shopper.
	function enforcePickupSelection(step, elig) {
		var sel = selectedShipMethodId();
		if (!sel || !CONFIG.PICKUP_LOCATIONS.hasOwnProperty(sel)) { return; }   // not on a pickup
		var blocked = elig[sel] && !elig[sel].ok;
		if (!blocked) {
			if (!CONFIG.PICKUP_STEAL_DEFAULT || state.userChose || state.defaultMoved) { return; }
		}
		var target = firstSelectableRatedRow(step);
		if (!target) { return; }
		if (selectRow(step, target) && !blocked) { state.defaultMoved = true; }
	}

	// A WWEX row that is visible and actually carries a price — never a row still reading
	// "Getting live rates…" or a contact-us message.
	function firstSelectableRatedRow(step) {
		var found = null;
		eachWwexRow(step, function (row) {
			if (found) { return; }
			if (row.style.display === 'none') { return; }
			var el = row.querySelector(SEL.methodPrice);
			if (!el || String(el.textContent).indexOf('$') === -1) { return; }
			found = row.getAttribute(SEL.methodRowIdAttr);
		});
		return found;
	}

	// A real .click() on the radio, not input.checked = true: SCA's model updates off the native
	// event, and a programmatic property set fires nothing (the same lesson as the autofill /
	// MutationObserver problem in the address form).
	function selectRow(step, shipItemId) {
		var rows = step.querySelectorAll(SEL.methodRow);
		for (var i = 0; i < rows.length; i++) {
			if (rows[i].getAttribute(SEL.methodRowIdAttr) !== shipItemId) { continue; }
			var input = rows[i].querySelector('input[name="delivery-options"]');
			if (input && !input.disabled && !input.checked) {
				try { input.click(); return true; } catch (e) { return false; }
			}
			return false;
		}
		return false;
	}

	function readCart() {
		var out = null;
		try {
			var LO = null;
			try { LO = require('LiveOrder.Model'); } catch (eReq) { LO = null; }
			var inst = LO && LO.getInstance && LO.getInstance();
			var lines = inst && inst.get && inst.get('lines');
			if (lines && lines.length) {
				out = [];
				var n = lines.length;
				for (var i = 0; i < n; i++) {
					var l = lines.at ? lines.at(i) : lines[i];
					var item = l && l.get ? l.get('item') : (l && l.item);
					var iid = item && (item.get ? item.get('internalid') : item.internalid);
					var qty = l && l.get ? l.get('quantity') : (l && l.quantity);
					if (iid) { out.push({ id: String(iid), qty: qty || 1 }); }
				}
				if (out.length) { return out; }
			}
		} catch (e) { /* fall through */ }
		try {
			var env = window.SC && SC.ENVIRONMENT && SC.ENVIRONMENT.CART;
			if (env && env.lines && env.lines.length) {
				out = [];
				env.lines.forEach(function (l) {
					var iid = l.item && l.item.internalid;
					if (iid) { out.push({ id: String(iid), qty: l.quantity || 1 }); }
				});
				if (out.length) { return out; }
			}
		} catch (e2) {}
		return null;
	}

	// 1.2.4 — the address the order will actually ship to, from the LiveOrder model. The
	// blank guest form is the ONLY flow with address inputs in the DOM; a returning shopper
	// picks a saved-address CARD and the review step has no inputs at all (both measured
	// 2026-08-24 — the extension sat idle there and the native $250s showed). Model shape
	// measured: LiveOrder.get('shipaddress') = selected address internalid,
	// LiveOrder.get('addresses') = Backbone collection of address models.
	function selectedAddress() {
		try {
			var LO = require('LiveOrder.Model');
			var inst = LO && LO.getInstance && LO.getInstance();
			if (!inst || !inst.get) { return null; }
			var addrId = inst.get('shipaddress');
			var addrs = inst.get('addresses');
			if (!addrId || !addrs) { return null; }
			if (addrs.get) {
				var m = addrs.get(addrId);
				if (m) { return m.toJSON ? m.toJSON() : (m.attributes || null); }
			}
			var n = addrs.length || 0;
			for (var i = 0; i < n; i++) {
				var a = addrs.at ? addrs.at(i) : addrs[i];
				var obj = a && (a.toJSON ? a.toJSON() : (a.attributes || a));
				if (obj && String(obj.internalid) === String(addrId)) { return obj; }
			}
		} catch (e) {}
		return null;
	}

	// 1.9.0 — the SHIPPING zip input, in preference order. Until now this was
	// `document.querySelector('input[name="zip"], input[id*="zip"]')` — the first zip-ish input
	// anywhere in the document. Once billing renders, or the wizard re-renders and reorders the
	// forms, "first" can be a DIFFERENT field, and the sticky reads added in 1.6.0 only defend
	// against a read going EMPTY, not against it returning someone else's value. That is the
	// phone-edit re-quote: nothing about the destination changed, but the key did.
	function shipInput(name) {
		// 1.10.5 — the shipping address FORM only exists on the shipping step, where the shipmethod
		// module renders beside it (S1). Anywhere else (Payment, Review) an address form on the page is
		// the BILLING one — measured 2026-10-21: the Payment step carries one .order-wizard-address-module
		// and no shipmethod module, and the fallbacks below rated the cart to the billing ZIP. Return
		// null there and let the callers use the model's selected shipping address.
		try { if (!document.querySelector(SEL.deliveryStep)) { return null; } } catch (e0) { return null; }
		var sels = ['#shipaddress-' + name, '[id^="shipaddress"][name="' + name + '"]',
		            '.order-wizard-address-module [name="' + name + '"]',
		            '[name="' + name + '"]'];
		for (var i = 0; i < sels.length; i++) {
			try {
				var all = document.querySelectorAll(sels[i]);
				for (var j = 0; j < all.length; j++) {
					if (!/^bill/i.test(all[j].id || '')) { return all[j]; }   // never a billing field
				}
			} catch (e) {}
		}
		return null;
	}

	// The raw contents of the shipping zip box, valid or not — needed to tell "still typing"
	// (accept quietly) from "typed something that is not a ZIP" (say so).
	function rawZipInput() {
		var el = shipInput('zip');
		return el && el.value ? String(el.value).trim() : '';
	}

	function readZip() {
		try {
			var v = rawZipInput();
			if (CONFIG.ZIP_RE.test(v)) { return v; }
			// 1.2.4: saved-address and review flows — the model's selected address.
			var addr = selectedAddress();
			var z = addr && addr.zip ? String(addr.zip).trim() : '';
			return CONFIG.ZIP_RE.test(z) ? z : null;
		} catch (e) { return null; }
	}


	// Residential. CONFIRMED against TT_Master_Theme: the address form renders
	// <input type="checkbox" name="isresidential" value="T" data-unchecked-value="F"> labelled
	// "This is a Residential Address", and the shipmethod step's model carries it as the STRING
	// "T"/"F" at model.addresses.0.isresidential — which is the step this extension runs in.
	//
	// Read the MODEL first: it is the value the order will actually be submitted with. The DOM
	// checkbox is only a fallback for the moment on the address step before the model updates.
	// Returns "T" or "F"; the Suitelet accepts either that or a boolean.
	//
	// Getting this wrong in the FALSE direction under-charges (commercial is the cheaper rate),
	// which is the safer failure and matches the server's own bias — but it is still a real cost
	// on LTL, so if this ever starts returning "F" for genuine home deliveries, fix it promptly.
	function readResidential() {
		try {
			// MEASURED 2026-08-24: SC.MODELS does not exist in this checkout app (the earlier
			// "model first" plan read a global that is never there). The DOM checkbox
			// <input name="isresidential" id="shipaddress-isresidential"> is on the SAME step as
			// the delivery methods and IS the value the address will be saved with — read it.
			var v = null;
			var box = shipInput('isresidential');
			if (box) { v = box.checked ? 'T' : 'F'; }
			if (v === null) {
				// 1.2.4: no checkbox on saved-address/review flows — the model's address carries
				// isresidential as "T"/"F" (measured).
				var addr = selectedAddress();
				if (addr && addr.isresidential != null) { v = addr.isresidential; }
			}
			if (v === true) { return 'T'; }
			var s = String(v == null ? '' : v).trim().toUpperCase();
			return (s === 'T' || s === 'TRUE' || s === 'Y' || s === '1') ? 'T' : 'F';
		} catch (e) { return 'F'; }
	}

	// Address fields straight off the form inputs — MEASURED 2026-08-24: the theme's address form
	// uses name="addr1"/"city"/"state"/"company" (state is a <select> whose value is the 2-letter
	// code, which is exactly what WWEX wants), and it shares the step with the delivery methods.
	// (SC.MODELS, the previous primary source, does not exist in this app — measured false.)
	function readAddrField(name) {
		try {
			var el = shipInput(name);          // 1.9.0 — shipping form first, see shipInput()
			if (el && el.value) { return String(el.value).trim(); }
			// 1.2.4: saved-address and review flows read the model's selected address.
			var addr = selectedAddress();
			return addr && addr[name] != null ? String(addr[name]).trim() : '';
		} catch (e) { return ''; }
	}

	function readEmail() {
		try {
			var el = document.querySelector('#guest-email');   // GuestCheckout's field, read-only peek
			return el && el.value ? el.value.trim() : '';
		} catch (e) { return ''; }
	}

	// --- utils -------------------------------------------------------------------------------

	function fmt(n) { return '$' + Number(n).toFixed(2); }

	function debounce(fn, ms) {
		var t = null;
		return function () { clearTimeout(t); t = setTimeout(fn, ms); };
	}

	// Two ways in. mountToApp is the supported SuiteCommerce entry point and it is the ONLY one
	// that hands us the container — which is how the service file's versioned asset path gets
	// resolved. The DOMContentLoaded path is kept as a fallback for the app-domain override case
	// and is a no-op once mountToApp has already booted.
	var booted = false;
	function bootOnce() { if (booted) { return; } booted = true; boot(); }

	if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bootOnce); }
	else { bootOnce(); }

	return {
		mountToApp: function (container) {
			state.container = container;
			booted = false;          // re-resolve now that the container exists
			bootOnce();
		}
	};
});

// upload-hash bust 2026-08-25T02:00:00Z (1.3.0 cart page coverage) — the extension uploader dedupes on a SERVER-SIDE md5 manifest;
// a failed deploy leaves the hash recorded, so the file is skipped forever until it changes.

// deploy-hash 20260930T160000Z — 1.10.0, handling basis (subtotal) in request + key

// deploy-hash 20261020T190000Z — 1.10.1, no-quote row copy survives re-render; carrier_error retried

// deploy-hash 20261021T150000Z — 1.10.3, spinner wording + slow label, 25s watchdog, summary Calculating, summary held un-debounced

// deploy-hash 20261021T190000Z — 1.10.4, re-price requires a quote; pending presentation held through re-renders

// deploy-hash 20261021T210000Z — 1.10.5, shipping form only on the shipping step; Review ends its quotes; review select pending copy

// deploy-hash 20261021T220000Z — 1.10.6, summary + review select repainted in the same microtask on Payment/Review
